import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
  AWSEmail: any;
  AWSIPAddress: any;
  AWSJSON: string;
  AWSPhone: any;
  AWSTime: any;
  AWSTimestamp: any;
  AWSURL: any;
  Long: any;
};

export type AddDirectDebitAgreementInput = {
  signatureData: Scalars['String'];
  signedDate: Scalars['String'];
};

export type AddMemberPaymentMethodInput = {
  bankAccount?: InputMaybe<BankAccountInput>;
  creditCard?: InputMaybe<CreditCardInput>;
  isDefault: Scalars['Boolean'];
  type: PaymentMethodType;
};

export type Address = {
  __typename?: 'Address';
  address: Scalars['String'];
  center?: Maybe<Array<Maybe<Scalars['Float']>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  fullText: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  streetOne: Scalars['String'];
  streetTwo?: Maybe<Scalars['String']>;
  zipPostcode?: Maybe<Scalars['String']>;
};

export type AddressSearchResult = {
  __typename?: 'AddressSearchResult';
  items?: Maybe<Array<Maybe<Address>>>;
};

export type AgreeToMembershipInput = {
  payInAdvanceMethod?: InputMaybe<MemberPaymentType>;
  signatureData: Scalars['String'];
};

export type BankAccountInput = {
  bsb?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  number: Scalars['String'];
};

export type CancelMyMembershipInput = {
  cancelReason?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
};

export type ChargeAmount = {
  __typename?: 'ChargeAmount';
  amount: PaymentBreakdown;
  frequency: MembershipPaymentFrequency;
};

export type Class = {
  __typename?: 'Class';
  blackoutEnd?: Maybe<Scalars['String']>;
  blackoutStart?: Maybe<Scalars['String']>;
  bookedIn?: Maybe<Scalars['Boolean']>;
  bookingWindow?: Maybe<Scalars['Int']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['String']>;
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  currentCapacity?: Maybe<Scalars['Int']>;
  currentlyWaiting?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lateCancellationCost?: Maybe<Scalars['Int']>;
  lateCancellationWindow?: Maybe<Scalars['Int']>;
  length: Scalars['Int'];
  maximumCapacity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  noShowCost?: Maybe<Scalars['Int']>;
  staffId: Scalars['String'];
  staffName?: Maybe<Scalars['String']>;
  startsAt: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  useCheckIn: Scalars['Boolean'];
  useWaitlist: Scalars['Boolean'];
  useWaitlistConfirmation?: Maybe<Scalars['Boolean']>;
  waitlistConfirmationWindow?: Maybe<Scalars['Int']>;
};

export type ClassBooking = {
  __typename?: 'ClassBooking';
  bookedOn: Scalars['String'];
  bookedServiceId?: Maybe<Scalars['String']>;
  bookedServiceType?: Maybe<ClassBookingServiceType>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['String']>;
  checkedInAt?: Maybe<Scalars['String']>;
  classId: Scalars['String'];
  className: Scalars['String'];
  id: Scalars['ID'];
  lateCancellationWindow?: Maybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
};

export type ClassBookingConnection = {
  __typename?: 'ClassBookingConnection';
  items?: Maybe<Array<Maybe<ClassBooking>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassBookingFilter = {
  memberId?: InputMaybe<Scalars['String']>;
  showActive?: InputMaybe<Scalars['Boolean']>;
  showCheckedIn?: InputMaybe<Scalars['Boolean']>;
};

export type ClassBookingResult = {
  __typename?: 'ClassBookingResult';
  class?: Maybe<Class>;
  classBooking?: Maybe<ClassBooking>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export enum ClassBookingServiceType {
  Gymleads = 'GYMLEADS',
  Membership = 'MEMBERSHIP',
  Package = 'PACKAGE',
  Trial = 'TRIAL'
}

export type ClassConnection = {
  __typename?: 'ClassConnection';
  items?: Maybe<Array<Maybe<Class>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassType = {
  __typename?: 'ClassType';
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  companyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type ClassTypeConnection = {
  __typename?: 'ClassTypeConnection';
  items?: Maybe<Array<Maybe<ClassType>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassWaitlist = {
  __typename?: 'ClassWaitlist';
  bookedServiceId?: Maybe<Scalars['String']>;
  bookedServiceType?: Maybe<ClassBookingServiceType>;
  classId: Scalars['String'];
  className: Scalars['String'];
  confirmedOn?: Maybe<Scalars['String']>;
  expiredOn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lockedUntil?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
  waitedOn: Scalars['String'];
};

export type ClassWaitlistConfirmResult = {
  __typename?: 'ClassWaitlistConfirmResult';
  class?: Maybe<Class>;
  classBooking?: Maybe<ClassBooking>;
  classWaitlist?: Maybe<ClassWaitlist>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type ClassWaitlistConnection = {
  __typename?: 'ClassWaitlistConnection';
  items?: Maybe<Array<Maybe<ClassWaitlist>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClassWaitlistResult = {
  __typename?: 'ClassWaitlistResult';
  class?: Maybe<Class>;
  classWaitlist?: Maybe<ClassWaitlist>;
  errors?: Maybe<Array<Maybe<Error>>>;
};

export type Club = {
  __typename?: 'Club';
  address?: Maybe<Scalars['AWSJSON']>;
  baseCurrency: Currency;
  clubWebPortal?: Maybe<ClubWebPortal>;
  company: Company;
  contactNumber?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  pricesIncludeTax: Scalars['Boolean'];
  registeredForTax: Scalars['Boolean'];
  taxNumber?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type ClubConnection = {
  __typename?: 'ClubConnection';
  items?: Maybe<Array<Maybe<Club>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type ClubWebPortal = {
  __typename?: 'ClubWebPortal';
  allowCancellation: Scalars['Boolean'];
  allowPaymentFrequencyUpdate: Scalars['Boolean'];
  allowPublicSignUp: Scalars['Boolean'];
  allowSuspension: Scalars['Boolean'];
  allowSuspensionRequest?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  buttonBackgroundColor?: Maybe<Scalars['String']>;
  buttonTextColor?: Maybe<Scalars['String']>;
  classTitle?: Maybe<Scalars['String']>;
  clubId: Scalars['String'];
  enabled: Scalars['Boolean'];
  logInText?: Maybe<Scalars['String']>;
  maximumSuspensionDays?: Maybe<Scalars['Int']>;
  minimumSuspensionDays?: Maybe<Scalars['Int']>;
  showBarcode?: Maybe<Scalars['Boolean']>;
  showClassAvailability?: Maybe<Scalars['Boolean']>;
  showPublicClasses: Scalars['Boolean'];
  textColor?: Maybe<Scalars['String']>;
  welcomeText?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  clubs?: Maybe<ClubConnection>;
  coverImageUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoImageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
};


export type CompanyClubsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};

export type CompanyMemberRequiredFields = {
  __typename?: 'CompanyMemberRequiredFields';
  address?: Maybe<Scalars['Boolean']>;
  barcode?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['Boolean']>;
};

export type CreditCardInput = {
  cvv: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  name: Scalars['String'];
  number: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  base: Scalars['Int'];
  code: Scalars['String'];
  exponent: Scalars['Int'];
};

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export enum DeviceOs {
  Android = 'ANDROID',
  Ios = 'IOS',
  Macos = 'MACOS',
  Web = 'WEB',
  Windows = 'WINDOWS'
}

export type DirectDebitProvider = {
  __typename?: 'DirectDebitProvider';
  baseCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logoUrl: Scalars['String'];
  name: Scalars['String'];
  termsAndConditionsUrl: Scalars['String'];
  url: Scalars['String'];
  username: Scalars['String'];
};

export type Error = {
  __typename?: 'Error';
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum Gender {
  Female = 'FEMALE',
  Intersex = 'INTERSEX',
  Male = 'MALE',
  Trans = 'TRANS',
  Unknown = 'UNKNOWN'
}

export type GymGoer = {
  __typename?: 'GymGoer';
  address?: Maybe<Scalars['AWSJSON']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  dependantIds?: Maybe<Array<Scalars['ID']>>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  familyName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  givenName: Scalars['String'];
  id: Scalars['ID'];
  keepDetailsInSync?: Maybe<Scalars['Boolean']>;
  memberships?: Maybe<Array<Maybe<GymGoerMembership>>>;
  mobileNumber?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
};

export type GymGoerDevice = {
  __typename?: 'GymGoerDevice';
  gymgoerId: Scalars['ID'];
  id: Scalars['ID'];
  os: DeviceOs;
  pushToken?: Maybe<Scalars['String']>;
};

export type GymGoerMembership = {
  __typename?: 'GymGoerMembership';
  companyId: Scalars['String'];
  isDependent?: Maybe<Scalars['Boolean']>;
  memberId: Scalars['String'];
};

export type GymGoerNotification = {
  __typename?: 'GymGoerNotification';
  created: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  gymgoerId: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  type: GymGoerNotificationType;
};

export type GymGoerNotificationConnection = {
  __typename?: 'GymGoerNotificationConnection';
  items: Array<Maybe<GymGoerNotification>>;
  latestRead?: Maybe<Scalars['String']>;
  nextToken?: Maybe<Scalars['String']>;
  unreadCount?: Maybe<Scalars['Int']>;
};

export enum GymGoerNotificationType {
  ClassCancelled = 'CLASS_CANCELLED',
  ClassTimeChanged = 'CLASS_TIME_CHANGED',
  WaitlistSpotAvailable = 'WAITLIST_SPOT_AVAILABLE',
  WaitlistSpotBooked = 'WAITLIST_SPOT_BOOKED'
}

export enum LimitFrequency {
  Daily = 'DAILY',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type Member = {
  __typename?: 'Member';
  activeMemberMembershipId?: Maybe<Scalars['String']>;
  activeMembershipId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['AWSJSON']>;
  amountOwed?: Maybe<Money>;
  barcode?: Maybe<Scalars['String']>;
  clubIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  dateOfBirth?: Maybe<Scalars['String']>;
  dependantIds?: Maybe<Array<Scalars['ID']>>;
  dependantOf?: Maybe<Scalars['ID']>;
  devicePushToken?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  emergencyContactName?: Maybe<Scalars['String']>;
  emergencyContactPhone?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  givenName: Scalars['String'];
  homeClubId: Scalars['String'];
  homeClubName: Scalars['String'];
  id: Scalars['ID'];
  lastVisitDate?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Scalars['String']>;
  privateNote?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  status: MemberStatus;
  visitCount?: Maybe<Scalars['Int']>;
};

export type MemberCharge = {
  __typename?: 'MemberCharge';
  companyId: Scalars['String'];
  date: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  dishonorAmount?: Maybe<Money>;
  dishonorReportingAmounts?: Maybe<ReportingAmount>;
  id: Scalars['ID'];
  memberId: Scalars['String'];
  membershipDays?: Maybe<Scalars['Int']>;
  owedReportingAmounts?: Maybe<ReportingAmount>;
  paidReportingAmounts?: Maybe<ReportingAmount>;
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  serviceAmount: Money;
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceReportingAmounts?: Maybe<ReportingAmount>;
  serviceType: PaymentServiceType;
  status: MemberChargeStatus;
  total: Money;
  totalOwed?: Maybe<Money>;
  totalPaid?: Maybe<Money>;
  totalReportingAmounts?: Maybe<ReportingAmount>;
  totalWrittenOff?: Maybe<Money>;
};

export type MemberChargeConnection = {
  __typename?: 'MemberChargeConnection';
  items?: Maybe<Array<MemberCharge>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberChargeResult = {
  __typename?: 'MemberChargeResult';
  errors?: Maybe<Array<Error>>;
  member?: Maybe<Member>;
  memberCharge?: Maybe<MemberCharge>;
};

export enum MemberChargeStatus {
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  WrittenOff = 'WRITTEN_OFF'
}

export type MemberClubMembership = {
  __typename?: 'MemberClubMembership';
  clubId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MemberClubMembershipConnection = {
  __typename?: 'MemberClubMembershipConnection';
  items?: Maybe<Array<Maybe<MemberClubMembership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberConnection = {
  __typename?: 'MemberConnection';
  items?: Maybe<Array<Maybe<Member>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberFees = {
  __typename?: 'MemberFees';
  adminFee?: Maybe<Scalars['Int']>;
  cancellationFee?: Maybe<Scalars['Int']>;
  fobFee?: Maybe<Scalars['Int']>;
  joinFee?: Maybe<Scalars['Int']>;
  suspensionFee?: Maybe<Scalars['Int']>;
};

export type MemberInvite = {
  __typename?: 'MemberInvite';
  acceptedAt?: Maybe<Scalars['String']>;
  clubIds: Array<Maybe<Scalars['String']>>;
  companyId: Scalars['String'];
  companyName: Scalars['String'];
  createdByName: Scalars['String'];
  disabledAt?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  expiresAt: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['String'];
};

export type MemberMembership = {
  __typename?: 'MemberMembership';
  adminFee?: Maybe<Scalars['Int']>;
  billingStartDate?: Maybe<Scalars['String']>;
  cancellationFee?: Maybe<Scalars['Int']>;
  companyId: Scalars['String'];
  directDebitProviderId?: Maybe<Scalars['String']>;
  dishonorFee?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  freeNumber?: Maybe<Scalars['Int']>;
  freePeriod?: Maybe<MembershipLength>;
  hasCustomFees: Scalars['Boolean'];
  id: Scalars['String'];
  initialDiscountAmount?: Maybe<Money>;
  initialDiscountPayments?: Maybe<Scalars['Int']>;
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount: Scalars['Int'];
  lengthFrequency: MembershipLength;
  memberId: Scalars['String'];
  memberName: Scalars['String'];
  membershipCancellationId?: Maybe<Scalars['ID']>;
  membershipId: Scalars['String'];
  membershipName: Scalars['String'];
  membershipSuspensionId?: Maybe<Scalars['ID']>;
  minimumAmountRemaining?: Maybe<Money>;
  paidInFull?: Maybe<Scalars['Boolean']>;
  payInFullOption?: Maybe<PayInFullOption>;
  payInFullPaymentOption?: Maybe<MemberPaymentType>;
  paymentAmount: Scalars['Int'];
  paymentFrequency: MembershipPaymentFrequency;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  signedAt?: Maybe<Scalars['String']>;
  startDate: Scalars['String'];
  suspendedUntil?: Maybe<Scalars['String']>;
  suspensionFee?: Maybe<Scalars['Int']>;
  transactionFee?: Maybe<Money>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type MemberMembershipResponse = {
  __typename?: 'MemberMembershipResponse';
  error?: Maybe<Error>;
  member?: Maybe<Member>;
  memberMembership?: Maybe<MemberMembership>;
  memberPayment?: Maybe<MemberPayment>;
};

export type MemberPackage = {
  __typename?: 'MemberPackage';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  companyId: Scalars['String'];
  expiresAt?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  memberId: Scalars['String'];
  name: Scalars['String'];
  packageId: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  purchasedAt: Scalars['String'];
  remainingClasses?: Maybe<Scalars['Int']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type MemberPackageConnection = {
  __typename?: 'MemberPackageConnection';
  items?: Maybe<Array<Maybe<MemberPackage>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberPackageResponse = {
  __typename?: 'MemberPackageResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberPackage?: Maybe<MemberPackage>;
  package?: Maybe<Package>;
};

export type MemberPayment = {
  __typename?: 'MemberPayment';
  amount: Money;
  attemptNumber: Scalars['Int'];
  companyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  failReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['String']>;
  memberChargeId?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
  memberPaymentMethodId?: Maybe<Scalars['String']>;
  membershipDays?: Maybe<Scalars['Int']>;
  merchantFee?: Maybe<Money>;
  paymentType: MemberPaymentType;
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  processedAt: Scalars['String'];
  providerId?: Maybe<Scalars['String']>;
  reportingAmounts?: Maybe<ReportingAmount>;
  reprocessedBy?: Maybe<Scalars['String']>;
  reprocessingFor?: Maybe<Scalars['String']>;
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceType: PaymentServiceType;
  status: PaymentStatus;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
  transactionFee?: Maybe<Money>;
};

export type MemberPaymentConnection = {
  __typename?: 'MemberPaymentConnection';
  items?: Maybe<Array<Maybe<MemberPayment>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberPaymentMethod = {
  __typename?: 'MemberPaymentMethod';
  accountName?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  maskedNumber: Scalars['String'];
  memberId: Scalars['String'];
  providerId: Scalars['String'];
  type: PaymentMethodType;
};

export type MemberPaymentMethodResult = {
  __typename?: 'MemberPaymentMethodResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberPaymentMethod?: Maybe<MemberPaymentMethod>;
};

export type MemberPaymentResult = {
  __typename?: 'MemberPaymentResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberCharge?: Maybe<MemberCharge>;
  memberPayment?: Maybe<MemberPayment>;
};

export enum MemberPaymentType {
  Cash = 'CASH',
  DirectDebit = 'DIRECT_DEBIT',
  Eftpos = 'EFTPOS',
  Manual = 'MANUAL'
}

export enum MemberStatus {
  AwaitingStart = 'AWAITING_START',
  CancellationPending = 'CANCELLATION_PENDING',
  CasualMember = 'CASUAL_MEMBER',
  Lead = 'LEAD',
  LongTermMember = 'LONG_TERM_MEMBER',
  Overdue = 'OVERDUE',
  PaidInFull = 'PAID_IN_FULL',
  PastMember = 'PAST_MEMBER',
  SigningUp = 'SIGNING_UP',
  Suspended = 'SUSPENDED',
  TrialMember = 'TRIAL_MEMBER'
}

export type MemberTrial = {
  __typename?: 'MemberTrial';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  companyId: Scalars['String'];
  endDate: Scalars['String'];
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount: Scalars['Int'];
  lengthFrequency: MembershipLength;
  memberId: Scalars['String'];
  name: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  purchasedAt: Scalars['String'];
  remainingClasses?: Maybe<Scalars['Int']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  trialId: Scalars['String'];
  visitLimit?: Maybe<Scalars['Int']>;
};

export type MemberTrialConnection = {
  __typename?: 'MemberTrialConnection';
  items?: Maybe<Array<Maybe<MemberTrial>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type MemberTrialResponse = {
  __typename?: 'MemberTrialResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberTrial?: Maybe<MemberTrial>;
  trial?: Maybe<Trial>;
};

export type Membership = {
  __typename?: 'Membership';
  adminFee?: Maybe<Scalars['Int']>;
  allowPaidInFull?: Maybe<Scalars['Boolean']>;
  availablePaymentPeriods?: Maybe<Array<Maybe<MembershipPaymentFrequency>>>;
  availableToPublic?: Maybe<Scalars['Boolean']>;
  baseCurrency: Currency;
  cancellationFee?: Maybe<Scalars['Int']>;
  clubIds: Array<Maybe<Scalars['String']>>;
  coverImageUrl?: Maybe<Scalars['String']>;
  createdBy: Staff;
  description?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  freeNumber?: Maybe<Scalars['Int']>;
  freePeriod?: Maybe<MembershipLength>;
  id: Scalars['ID'];
  initialDiscountPayments?: Maybe<Scalars['Int']>;
  initialDiscountPercentage?: Maybe<Scalars['Float']>;
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  paidInFullOnly?: Maybe<Scalars['Boolean']>;
  payInFullOptions?: Maybe<Array<PayInFullOption>>;
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentFrequency?: Maybe<MembershipPaymentFrequency>;
  publishedAt?: Maybe<Scalars['String']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  status: MembershipStatus;
  suspensionFee?: Maybe<Scalars['Int']>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  visitLimit?: Maybe<Scalars['Int']>;
  visitLimitFrequency?: Maybe<LimitFrequency>;
};

export type MembershipAmountsResponse = {
  __typename?: 'MembershipAmountsResponse';
  membershipAmount: Money;
  suspensionFee: Money;
};

export type MembershipCancellation = {
  __typename?: 'MembershipCancellation';
  cancelReason?: Maybe<Scalars['String']>;
  cancellationFeeAmount?: Maybe<Scalars['Int']>;
  companyId: Scalars['ID'];
  endDate: Scalars['String'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
};

export type MembershipCancellationResult = {
  __typename?: 'MembershipCancellationResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberMembership?: Maybe<MemberMembership>;
  membershipCancellation?: Maybe<MembershipCancellation>;
};

export type MembershipConnection = {
  __typename?: 'MembershipConnection';
  items?: Maybe<Array<Maybe<Membership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum MembershipLength {
  Day = 'DAY',
  Fortnight = 'FORTNIGHT',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export enum MembershipPaymentFrequency {
  Fortnightly = 'FORTNIGHTLY',
  FourWeekly = 'FOUR_WEEKLY',
  Monthly = 'MONTHLY',
  OnceOff = 'ONCE_OFF',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export enum MembershipStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type MembershipSuspension = {
  __typename?: 'MembershipSuspension';
  approvedAt?: Maybe<Scalars['String']>;
  clubId?: Maybe<Scalars['String']>;
  companyId: Scalars['ID'];
  deniedAt?: Maybe<Scalars['String']>;
  deniedReason?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  handledByStaffId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ignoreFee?: Maybe<Scalars['Boolean']>;
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
  requireApproval?: Maybe<Scalars['Boolean']>;
  startDate: Scalars['String'];
  suspendReason?: Maybe<Scalars['String']>;
  suspensionFeeAmount?: Maybe<Scalars['Int']>;
};

export type MembershipSuspensionResult = {
  __typename?: 'MembershipSuspensionResult';
  errors?: Maybe<Array<Maybe<Error>>>;
  memberMembership?: Maybe<MemberMembership>;
  membershipSuspension?: Maybe<MembershipSuspension>;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Long'];
  currency: Currency;
  scale: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addMemberPaymentMethod?: Maybe<MemberPaymentMethodResult>;
  agreeToCurrentMembership: MemberMembershipResponse;
  bookMemberIntoClass?: Maybe<ClassBookingResult>;
  bookMemberIntoWaitlist?: Maybe<ClassWaitlistResult>;
  cancelClassBooking?: Maybe<ClassBookingResult>;
  cancelClassCheckIn?: Maybe<ClassBookingResult>;
  cancelClassWaitlist?: Maybe<ClassWaitlistResult>;
  cancelMembershipCancellation?: Maybe<MembershipCancellationResult>;
  cancelMyMembership?: Maybe<MembershipCancellationResult>;
  changePaymentFrequency?: Maybe<MemberMembershipResponse>;
  checkInMemberForClass?: Maybe<ClassBookingResult>;
  confirmClassWaitlist?: Maybe<ClassWaitlistConfirmResult>;
  markAllGymGoerNotificationsAsRead?: Maybe<Scalars['String']>;
  purchaseMemberPackage?: Maybe<MemberPackageResponse>;
  purchaseMemberTrial?: Maybe<MemberTrialResponse>;
  redeemMemberInvite?: Maybe<MemberInvite>;
  registerGymGoerDevice?: Maybe<GymGoerDevice>;
  removeMemberPaymentMethod?: Maybe<MemberPaymentMethodResult>;
  reprocessFailedMemberPayment?: Maybe<MemberPaymentResult>;
  setMemberPaymentMethodAsDefault?: Maybe<MemberPaymentMethodResult>;
  settleAccount?: Maybe<MemberChargeResult>;
  settleMemberCharge?: Maybe<MemberChargeResult>;
  startPublicMembershipSignUp?: Maybe<StartPublicMembershipSignUpResponse>;
  stopMyMembershipSuspension?: Maybe<MembershipSuspensionResult>;
  suspendMyMembership?: Maybe<MembershipSuspensionResult>;
  updateMeGymGoer?: Maybe<GymGoer>;
  updateNotificationPreferences?: Maybe<NotificationPreferences>;
  updatePushTokenForDevice?: Maybe<GymGoerDevice>;
};


export type MutationAddMemberPaymentMethodArgs = {
  input: AddMemberPaymentMethodInput;
  memberId: Scalars['ID'];
};


export type MutationAgreeToCurrentMembershipArgs = {
  input: AgreeToMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationBookMemberIntoClassArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationBookMemberIntoWaitlistArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelClassBookingArgs = {
  cancellationReason?: InputMaybe<Scalars['String']>;
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelClassCheckInArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelClassWaitlistArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationCancelMembershipCancellationArgs = {
  memberId: Scalars['ID'];
  membershipCancellationId: Scalars['ID'];
};


export type MutationCancelMyMembershipArgs = {
  input: CancelMyMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationChangePaymentFrequencyArgs = {
  memberId: Scalars['ID'];
  paymentFrequency: MembershipPaymentFrequency;
};


export type MutationCheckInMemberForClassArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationConfirmClassWaitlistArgs = {
  classId: Scalars['String'];
  memberId: Scalars['String'];
};


export type MutationPurchaseMemberPackageArgs = {
  input: PurchaseMemberPackageInput;
  memberId: Scalars['ID'];
  packageId: Scalars['ID'];
};


export type MutationPurchaseMemberTrialArgs = {
  input: PurchaseMemberTrialInput;
  memberId: Scalars['ID'];
  trialId: Scalars['ID'];
};


export type MutationRedeemMemberInviteArgs = {
  id: Scalars['ID'];
  input: RedeemMemberInviteInput;
};


export type MutationRegisterGymGoerDeviceArgs = {
  input: RegisterGymGoerDeviceInput;
};


export type MutationRemoveMemberPaymentMethodArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationReprocessFailedMemberPaymentArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationSetMemberPaymentMethodAsDefaultArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationSettleAccountArgs = {
  memberId: Scalars['ID'];
};


export type MutationSettleMemberChargeArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationStartPublicMembershipSignUpArgs = {
  input: StartPublicMembershipSignUpInput;
};


export type MutationStopMyMembershipSuspensionArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type MutationSuspendMyMembershipArgs = {
  input: SuspendMyMembershipInput;
  memberId: Scalars['ID'];
};


export type MutationUpdateMeGymGoerArgs = {
  input: UpdateMeGymGoerInput;
};


export type MutationUpdateNotificationPreferencesArgs = {
  input: UpdateNotificationPreferencesInput;
};


export type MutationUpdatePushTokenForDeviceArgs = {
  id: Scalars['ID'];
  input: RegisterGymGoerDeviceInput;
};

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  chatMessage?: Maybe<NotificationPreferencesOptions>;
  classBooked?: Maybe<NotificationPreferencesOptions>;
  classCancelled?: Maybe<NotificationPreferencesOptions>;
  classTimeChanged?: Maybe<NotificationPreferencesOptions>;
  classWaitlistAvailable?: Maybe<NotificationPreferencesOptions>;
  memberRepliesToEmail?: Maybe<NotificationPreferencesOptions>;
  memberRepliesToSms?: Maybe<NotificationPreferencesOptions>;
  newSignUp?: Maybe<NotificationPreferencesOptions>;
  paymentFailed?: Maybe<NotificationPreferencesOptions>;
  paymentSucceeded?: Maybe<NotificationPreferencesOptions>;
  purchasesAPackage?: Maybe<NotificationPreferencesOptions>;
};

export type NotificationPreferencesInput = {
  email?: InputMaybe<Scalars['Boolean']>;
  push?: InputMaybe<Scalars['Boolean']>;
  sms?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationPreferencesOptions = {
  __typename?: 'NotificationPreferencesOptions';
  email?: Maybe<Scalars['Boolean']>;
  push?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
};

export type Order = {
  __typename?: 'Order';
  amount: Money;
  clubId: Scalars['ID'];
  companyId: Scalars['String'];
  created: Scalars['String'];
  currency: Currency;
  discount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  invoiceId: Scalars['String'];
  memberName?: Maybe<Scalars['String']>;
  memberPaymentId?: Maybe<Scalars['ID']>;
  outstanding: Money;
  paid?: Maybe<Money>;
  refundReason?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['String']>;
  status: OrderStatus;
  subtotal: Money;
  tax: Money;
  total: Money;
  totalQuantity: Scalars['Int'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  amount: Money;
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  id: Scalars['ID'];
  memberId?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  productId: Scalars['String'];
  productName?: Maybe<Scalars['String']>;
  productStockId: Scalars['ID'];
  quantity: Scalars['Int'];
  refundReason?: Maybe<Scalars['String']>;
  refundedAt?: Maybe<Scalars['String']>;
  total: Money;
};

export enum OrderStatus {
  Finalized = 'FINALIZED',
  InProgress = 'IN_PROGRESS',
  Paid = 'PAID',
  PartialPayment = 'PARTIAL_PAYMENT',
  Refunded = 'REFUNDED'
}

export type Package = {
  __typename?: 'Package';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  name: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['String']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type PayInFullOption = {
  __typename?: 'PayInFullOption';
  amount: Scalars['Float'];
  months: Scalars['Int'];
};

export type PayInFullOptionInput = {
  amount: Scalars['Float'];
  months: Scalars['Int'];
};

export type PaymentBreakdown = {
  __typename?: 'PaymentBreakdown';
  amount: Money;
  discount?: Maybe<Money>;
  merchantFee: Money;
  subTotal: Money;
  tax: Money;
  total: Money;
  transactionFee: Money;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  baseCurrency: Currency;
  directDebitProviderId: Scalars['String'];
  firstAmount: PaymentBreakdown;
  memberFees: MemberFees;
  memberId: Scalars['ID'];
  membershipId: Scalars['ID'];
  nextChargeDate: Scalars['String'];
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  regularAmount: ChargeAmount;
  transactionFees: TransactionFees;
};

export enum PaymentMethodType {
  Amex = 'AMEX',
  BankAccount = 'BANK_ACCOUNT',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export enum PaymentServiceType {
  BalancePayment = 'BALANCE_PAYMENT',
  DishonorFee = 'DISHONOR_FEE',
  ImportOverdueBalance = 'IMPORT_OVERDUE_BALANCE',
  LateCancellation = 'LATE_CANCELLATION',
  Membership = 'MEMBERSHIP',
  MembershipCancellation = 'MEMBERSHIP_CANCELLATION',
  MissedClass = 'MISSED_CLASS',
  Package = 'PACKAGE',
  PersonalTraining = 'PERSONAL_TRAINING',
  Product = 'PRODUCT',
  Refund = 'REFUND',
  SuspensionFee = 'SUSPENSION_FEE',
  Trial = 'TRIAL',
  WriteOff = 'WRITE_OFF'
}

export enum PaymentStatus {
  Dishonored = 'DISHONORED',
  Error = 'ERROR',
  Failed = 'FAILED',
  Paid = 'PAID',
  Processing = 'PROCESSING',
  Voided = 'VOIDED',
  WriteOff = 'WRITE_OFF'
}

export type PublicFileUpload = {
  __typename?: 'PublicFileUpload';
  getUrl?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export type PublicOrderResponse = {
  __typename?: 'PublicOrderResponse';
  order?: Maybe<Order>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
};

export enum PublicSearchDocumentType {
  ClassType = 'CLASS_TYPE',
  Club = 'CLUB',
  Company = 'COMPANY',
  Membership = 'MEMBERSHIP',
  Package = 'PACKAGE',
  Staff = 'STAFF',
  Trial = 'TRIAL'
}

export type PublicSearchInput = {
  clubIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  companyId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  type?: InputMaybe<PublicSearchDocumentType>;
};

export type PublicSearchResult = {
  __typename?: 'PublicSearchResult';
  items: Array<Maybe<PublicSearchResultItem>>;
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage: Scalars['Int'];
  resultCount: Scalars['Int'];
};

export type PublicSearchResultItem = {
  __typename?: 'PublicSearchResultItem';
  address?: Maybe<Scalars['AWSJSON']>;
  detail?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  thumbnailUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: PublicSearchDocumentType;
};

export enum PublicUploadFileType {
  ClassTypeThumbnail = 'CLASS_TYPE_THUMBNAIL',
  CompanyCoverImage = 'COMPANY_COVER_IMAGE',
  CompanyLogo = 'COMPANY_LOGO',
  MembershipCoverImage = 'MEMBERSHIP_COVER_IMAGE',
  MembershipThumbnail = 'MEMBERSHIP_THUMBNAIL',
  MemberProfilePicture = 'MEMBER_PROFILE_PICTURE',
  PosImage = 'POS_IMAGE',
  PosThumbnail = 'POS_THUMBNAIL',
  PtServiceThumbnail = 'PT_SERVICE_THUMBNAIL',
  StaffProfilePicture = 'STAFF_PROFILE_PICTURE',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type PurchaseMemberPackageInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  expiresAt: Scalars['String'];
  fobFee?: InputMaybe<Scalars['Int']>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount?: InputMaybe<Scalars['Int']>;
  lengthFrequency?: InputMaybe<MembershipLength>;
  paymentAmount?: InputMaybe<Scalars['Int']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitLimit?: InputMaybe<Scalars['Int']>;
  visitLimitFrequency?: InputMaybe<LimitFrequency>;
};

export type PurchaseMemberTrialInput = {
  adminFee?: InputMaybe<Scalars['Int']>;
  fobFee?: InputMaybe<Scalars['Int']>;
  joinFee?: InputMaybe<Scalars['Int']>;
  lengthAmount: Scalars['Int'];
  lengthFrequency: MembershipLength;
  paymentAmount?: InputMaybe<Scalars['Int']>;
  restrictedClassTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  visitLimit?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  getActivePaymentDetailsForMember?: Maybe<PaymentDetails>;
  getAmountForMembershipFrequency?: Maybe<MembershipAmountsResponse>;
  getClassBookingsForMember?: Maybe<ClassBookingConnection>;
  getClassWaitlistForMember?: Maybe<ClassWaitlistConnection>;
  getClub?: Maybe<Club>;
  getCompany?: Maybe<Company>;
  getCompanyMemberRequiredFields?: Maybe<CompanyMemberRequiredFields>;
  getDirectDebitProvider?: Maybe<DirectDebitProvider>;
  getGymGoerDevices?: Maybe<Array<GymGoerDevice>>;
  getMeGymGoer?: Maybe<GymGoer>;
  getMember?: Maybe<Member>;
  getMemberActiveMembership?: Maybe<MemberMembership>;
  getMemberCharge?: Maybe<MemberCharge>;
  getMemberCharges?: Maybe<MemberChargeConnection>;
  getMemberChargesForMember?: Maybe<MemberChargeConnection>;
  getMemberClass?: Maybe<Class>;
  getMemberFileUploadUrl?: Maybe<PublicFileUpload>;
  getMemberMembership?: Maybe<MemberMembership>;
  getMemberMemberships?: Maybe<Array<MemberMembership>>;
  getMemberPackage?: Maybe<MemberPackage>;
  getMemberPackagesForMember?: Maybe<MemberPackageConnection>;
  getMemberPaymentMethod?: Maybe<MemberPaymentMethod>;
  getMemberPaymentMethods?: Maybe<Array<Maybe<MemberPaymentMethod>>>;
  getMemberPaymentsForChargeId?: Maybe<Array<MemberPayment>>;
  getMemberPaymentsForMember?: Maybe<MemberPaymentConnection>;
  getMemberTrial?: Maybe<MemberTrial>;
  getMemberTrialsForMember?: Maybe<MemberTrialConnection>;
  getMembership?: Maybe<Membership>;
  getMembershipCancellation?: Maybe<MembershipCancellation>;
  getMembershipSuspension?: Maybe<MembershipSuspension>;
  getMyGymGoerNotifications?: Maybe<GymGoerNotificationConnection>;
  getMyMemberClubs?: Maybe<MemberClubMembershipConnection>;
  getMyMemberships?: Maybe<Array<Maybe<Member>>>;
  getMyNotificationPreferences?: Maybe<NotificationPreferences>;
  getOrderByInvoice?: Maybe<PublicOrderResponse>;
  getPackage?: Maybe<Package>;
  getPublicClassTypes?: Maybe<ClassTypeConnection>;
  getPublicClasses?: Maybe<ClassConnection>;
  getPublicMemberships?: Maybe<Array<Maybe<Membership>>>;
  getPublicPackages?: Maybe<Array<Maybe<Package>>>;
  getPublicTrials?: Maybe<Array<Maybe<Trial>>>;
  getScheduledMemberPaymentsForChargeId?: Maybe<Array<ScheduledMemberPayment>>;
  getScheduledMemberPaymentsForMember?: Maybe<ScheduledMemberPaymentConnection>;
  getTrial?: Maybe<Trial>;
  publicSearch?: Maybe<PublicSearchResult>;
  remainingAmountForMembership?: Maybe<Money>;
  searchForAddress?: Maybe<AddressSearchResult>;
};


export type QueryGetActivePaymentDetailsForMemberArgs = {
  memberId: Scalars['ID'];
  paymentMethodType: PaymentMethodType;
};


export type QueryGetAmountForMembershipFrequencyArgs = {
  id: Scalars['ID'];
  paymentFrequency: MembershipPaymentFrequency;
};


export type QueryGetClassBookingsForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
};


export type QueryGetClassWaitlistForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  startsAt: Scalars['String'];
};


export type QueryGetClubArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyMemberRequiredFieldsArgs = {
  id: Scalars['ID'];
};


export type QueryGetDirectDebitProviderArgs = {
  id: Scalars['ID'];
};


export type QueryGetMemberArgs = {
  id: Scalars['ID'];
};


export type QueryGetMemberActiveMembershipArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberChargeArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberChargesArgs = {
  clubId: Scalars['ID'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  startsAt: Scalars['String'];
};


export type QueryGetMemberChargesForMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberClassArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberFileUploadUrlArgs = {
  entityId?: InputMaybe<Scalars['ID']>;
  fileType: Scalars['String'];
  index?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  uploadFileType: PublicUploadFileType;
};


export type QueryGetMemberMembershipArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberMembershipsArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberPackageArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberPackagesForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberPaymentMethodArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberPaymentMethodsArgs = {
  memberId: Scalars['ID'];
};


export type QueryGetMemberPaymentsForChargeIdArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberPaymentsForMemberArgs = {
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  startsAt?: InputMaybe<Scalars['String']>;
};


export type QueryGetMemberTrialArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMemberTrialsForMemberArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMembershipArgs = {
  id: Scalars['ID'];
};


export type QueryGetMembershipCancellationArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMembershipSuspensionArgs = {
  id: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetMyGymGoerNotificationsArgs = {
  before: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrderByInvoiceArgs = {
  clubId: Scalars['ID'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryGetPackageArgs = {
  id: Scalars['ID'];
};


export type QueryGetPublicClassTypesArgs = {
  clubId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetPublicClassesArgs = {
  classTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId?: InputMaybe<Scalars['String']>;
  staffIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsAt: Scalars['String'];
};


export type QueryGetPublicMembershipsArgs = {
  companyId: Scalars['ID'];
};


export type QueryGetPublicPackagesArgs = {
  companyId: Scalars['ID'];
};


export type QueryGetPublicTrialsArgs = {
  companyId: Scalars['ID'];
};


export type QueryGetScheduledMemberPaymentsForChargeIdArgs = {
  memberChargeId: Scalars['ID'];
  memberId: Scalars['ID'];
};


export type QueryGetScheduledMemberPaymentsForMemberArgs = {
  clubId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId: Scalars['String'];
  nextToken?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<PaymentServiceType>;
};


export type QueryGetTrialArgs = {
  id: Scalars['ID'];
};


export type QueryPublicSearchArgs = {
  input?: InputMaybe<PublicSearchInput>;
};


export type QueryRemainingAmountForMembershipArgs = {
  endDate: Scalars['String'];
  memberId: Scalars['ID'];
  memberMembershipId: Scalars['ID'];
};


export type QuerySearchForAddressArgs = {
  search: Scalars['String'];
};

export type RedeemMemberInviteInput = {
  memberId: Scalars['String'];
  redeemToken: Scalars['String'];
};

export type RegisterGymGoerDeviceInput = {
  os: DeviceOs;
  pushToken?: InputMaybe<Scalars['String']>;
};

export type ReportingAmount = {
  __typename?: 'ReportingAmount';
  amount?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  merchantFee?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  tax?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Float']>;
};

export type ScheduledMemberPayment = {
  __typename?: 'ScheduledMemberPayment';
  amount: Money;
  attemptNumber: Scalars['Int'];
  companyId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Money>;
  discountPercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  memberChargeId?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  memberMembershipId?: Maybe<Scalars['String']>;
  membershipDays?: Maybe<Scalars['Int']>;
  merchantFee?: Maybe<Money>;
  proRataAmount?: Maybe<Money>;
  proRataDays?: Maybe<Scalars['Int']>;
  reportingAmounts?: Maybe<ReportingAmount>;
  scheduledAt: Scalars['String'];
  serviceId: Scalars['String'];
  servicePeriod?: Maybe<Scalars['String']>;
  serviceType: PaymentServiceType;
  subtotal?: Maybe<Money>;
  tax?: Maybe<Money>;
  total: Money;
  transactionFee?: Maybe<Money>;
};

export type ScheduledMemberPaymentConnection = {
  __typename?: 'ScheduledMemberPaymentConnection';
  items?: Maybe<Array<Maybe<ScheduledMemberPayment>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Staff = {
  __typename?: 'Staff';
  company?: Maybe<Company>;
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  familyName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  givenName: Scalars['String'];
  id: Scalars['ID'];
  isPersonalTrainer?: Maybe<Scalars['Boolean']>;
  mobileNumber?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
};

export type StaffClubMembership = {
  __typename?: 'StaffClubMembership';
  clubId: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  role: Scalars['String'];
};

export type StaffClubMembershipConnection = {
  __typename?: 'StaffClubMembershipConnection';
  items?: Maybe<Array<Maybe<StaffClubMembership>>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type StartPublicMembershipSignUpInput = {
  clubId: Scalars['ID'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  membershipId: Scalars['ID'];
  mobileNumber?: InputMaybe<Scalars['String']>;
  paidInFull?: InputMaybe<Scalars['Boolean']>;
  payInFullOption?: InputMaybe<PayInFullOptionInput>;
  paymentFrequency?: InputMaybe<MembershipPaymentFrequency>;
  recaptchaToken: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
};

export type StartPublicMembershipSignUpResponse = {
  __typename?: 'StartPublicMembershipSignUpResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  success: Scalars['Boolean'];
};

export type SuspendMyMembershipInput = {
  endDate: Scalars['String'];
  startDate: Scalars['String'];
  suspendReason?: InputMaybe<Scalars['String']>;
};

export type TransactionFees = {
  __typename?: 'TransactionFees';
  dishonorFee?: Maybe<Scalars['Int']>;
  merchantFeePercentage?: Maybe<Scalars['Float']>;
  transactionFee?: Maybe<Scalars['Int']>;
};

export type Trial = {
  __typename?: 'Trial';
  adminFee?: Maybe<Scalars['Int']>;
  baseCurrency: Currency;
  description?: Maybe<Scalars['String']>;
  fobFee?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  joinFee?: Maybe<Scalars['Int']>;
  lengthAmount?: Maybe<Scalars['Int']>;
  lengthFrequency?: Maybe<MembershipLength>;
  name: Scalars['String'];
  paymentAmount?: Maybe<Scalars['Float']>;
  publishedAt?: Maybe<Scalars['String']>;
  restrictedClassTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  thumbnailImageUrl?: Maybe<Scalars['String']>;
};

export type UpdateMeGymGoerInput = {
  address?: InputMaybe<Scalars['AWSJSON']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  givenName?: InputMaybe<Scalars['String']>;
  mobileNumber?: InputMaybe<Scalars['String']>;
  profilePictureUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationPreferencesInput = {
  chatMessage?: InputMaybe<NotificationPreferencesInput>;
  classBooked?: InputMaybe<NotificationPreferencesInput>;
  classCancelled?: InputMaybe<NotificationPreferencesInput>;
  classTimeChanged?: InputMaybe<NotificationPreferencesInput>;
  classWaitlistAvailable?: InputMaybe<NotificationPreferencesInput>;
  paymentFailed?: InputMaybe<NotificationPreferencesInput>;
  paymentSucceeded?: InputMaybe<NotificationPreferencesInput>;
};

export type SearchForAddressQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type SearchForAddressQuery = { __typename?: 'Query', searchForAddress?: { __typename?: 'AddressSearchResult', items?: Array<{ __typename?: 'Address', fullText: string, address: string, streetOne: string, streetTwo?: string | null | undefined, city?: string | null | undefined, zipPostcode?: string | null | undefined, state?: string | null | undefined, country?: string | null | undefined, center?: Array<number | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type BookMemberIntoClassMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type BookMemberIntoClassMutation = { __typename?: 'Mutation', bookMemberIntoClass?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string, lateCancellationWindow?: number | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassBookingMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
  cancellationReason?: InputMaybe<Scalars['String']>;
}>;


export type CancelClassBookingMutation = { __typename?: 'Mutation', cancelClassBooking?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, className: string, checkedInAt?: string | null | undefined, startsAt: string, lateCancellationWindow?: number | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type BookMemberIntoWaitlistMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type BookMemberIntoWaitlistMutation = { __typename?: 'Mutation', bookMemberIntoWaitlist?: { __typename?: 'ClassWaitlistResult', classWaitlist?: { __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassWaitlistMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type CancelClassWaitlistMutation = { __typename?: 'Mutation', cancelClassWaitlist?: { __typename?: 'ClassWaitlistResult', classWaitlist?: { __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type ConfirmClassWaitlistMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type ConfirmClassWaitlistMutation = { __typename?: 'Mutation', confirmClassWaitlist?: { __typename?: 'ClassWaitlistConfirmResult', classWaitlist?: { __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined, classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, className: string, checkedInAt?: string | null | undefined, startsAt: string, lateCancellationWindow?: number | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CheckInMemberForClassMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type CheckInMemberForClassMutation = { __typename?: 'Mutation', checkInMemberForClass?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string, lateCancellationWindow?: number | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelClassCheckInMutationVariables = Exact<{
  classId: Scalars['String'];
  memberId: Scalars['String'];
}>;


export type CancelClassCheckInMutation = { __typename?: 'Mutation', cancelClassCheckIn?: { __typename?: 'ClassBookingResult', classBooking?: { __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string, lateCancellationWindow?: number | null | undefined } | null | undefined, class?: { __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassBookingsForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetClassBookingsForMemberQuery = { __typename?: 'Query', getClassBookingsForMember?: { __typename?: 'ClassBookingConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassBooking', id: string, memberId: string, classId: string, bookedOn: string, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, checkedInAt?: string | null | undefined, className: string, startsAt: string, lateCancellationWindow?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetClassWaitlistForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  startsAt: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetClassWaitlistForMemberQuery = { __typename?: 'Query', getClassWaitlistForMember?: { __typename?: 'ClassWaitlistConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassWaitlist', id: string, memberId: string, classId: string, waitedOn: string, className: string, startsAt: string, lockedUntil?: string | null | undefined, expiredOn?: string | null | undefined, confirmedOn?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetPublicClassesQueryVariables = Exact<{
  clubId: Scalars['String'];
  companyId: Scalars['String'];
  startsAt: Scalars['String'];
  staffIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  classTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  endsAt?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId?: InputMaybe<Scalars['String']>;
}>;


export type GetPublicClassesQuery = { __typename?: 'Query', getPublicClasses?: { __typename?: 'ClassConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'Class', id: string, name?: string | null | undefined, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubId: string, staffId: string, staffName?: string | null | undefined, startsAt: string, length: number, maximumCapacity?: number | null | undefined, currentCapacity?: number | null | undefined, useWaitlist: boolean, useCheckIn: boolean, cancelledAt?: string | null | undefined, cancellationReason?: string | null | undefined, waitlistConfirmationWindow?: number | null | undefined, bookedIn?: boolean | null | undefined, currentlyWaiting?: boolean | null | undefined, lateCancellationWindow?: number | null | undefined, lateCancellationCost?: number | null | undefined, noShowCost?: number | null | undefined, bookingWindow?: number | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetPublicClassTypesQueryVariables = Exact<{
  companyId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
  clubId?: InputMaybe<Scalars['String']>;
}>;


export type GetPublicClassTypesQuery = { __typename?: 'Query', getPublicClassTypes?: { __typename?: 'ClassTypeConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ClassType', id: string, name: string, description?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, companyId: string, clubIds?: Array<string | null | undefined> | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMyMemberClubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyMemberClubsQuery = { __typename?: 'Query', getMyMemberClubs?: { __typename?: 'MemberClubMembershipConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberClubMembership', id: string, name: string, clubId: string } | null | undefined> | null | undefined } | null | undefined };

export type GetClubQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetClubQuery = { __typename?: 'Query', getClub?: { __typename?: 'Club', id: string, name: string, description?: string | null | undefined, address?: string | null | undefined, pricesIncludeTax: boolean, timezone: string, countryCode: string, taxNumber?: string | null | undefined, contactNumber?: string | null | undefined, baseCurrency: { __typename?: 'Currency', base: number, code: string, exponent: number }, clubWebPortal?: { __typename?: 'ClubWebPortal', allowCancellation: boolean, allowPaymentFrequencyUpdate: boolean, allowPublicSignUp: boolean, allowSuspension: boolean, backgroundColor?: string | null | undefined, buttonBackgroundColor?: string | null | undefined, buttonTextColor?: string | null | undefined, clubId: string, enabled: boolean, logInText?: string | null | undefined, maximumSuspensionDays?: number | null | undefined, minimumSuspensionDays?: number | null | undefined, showPublicClasses: boolean, textColor?: string | null | undefined, welcomeText?: string | null | undefined, classTitle?: string | null | undefined, showBarcode?: boolean | null | undefined, showClassAvailability?: boolean | null | undefined, allowSuspensionRequest?: boolean | null | undefined } | null | undefined, company: { __typename?: 'Company', id: string, logoImageUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, name: string, description?: string | null | undefined, termsAndConditionsUrl?: string | null | undefined, websiteUrl?: string | null | undefined } } | null | undefined };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', id: string, name: string, description?: string | null | undefined, termsAndConditionsUrl?: string | null | undefined, logoImageUrl?: string | null | undefined, coverImageUrl?: string | null | undefined, websiteUrl?: string | null | undefined } | null | undefined };

export type GetCompanyMemberRequiredFieldsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyMemberRequiredFieldsQuery = { __typename?: 'Query', getCompanyMemberRequiredFields?: { __typename?: 'CompanyMemberRequiredFields', companyId?: string | null | undefined, firstName?: boolean | null | undefined, lastName?: boolean | null | undefined, email?: boolean | null | undefined, dateOfBirth?: boolean | null | undefined, mobile?: boolean | null | undefined, address?: boolean | null | undefined, barcode?: boolean | null | undefined } | null | undefined };

export type GetDirectDebitProviderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDirectDebitProviderQuery = { __typename?: 'Query', getDirectDebitProvider?: { __typename?: 'DirectDebitProvider', id: string, name: string, description?: string | null | undefined, url: string, logoUrl: string, termsAndConditionsUrl: string, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetMemberFileUploadUrlQueryVariables = Exact<{
  memberId: Scalars['ID'];
  uploadFileType: PublicUploadFileType;
  fileType: Scalars['String'];
  entityId?: InputMaybe<Scalars['ID']>;
  index?: InputMaybe<Scalars['Int']>;
}>;


export type GetMemberFileUploadUrlQuery = { __typename?: 'Query', getMemberFileUploadUrl?: { __typename?: 'PublicFileUpload', uploadUrl?: string | null | undefined, getUrl?: string | null | undefined } | null | undefined };

export type GetMyGymGoerNotificationsQueryVariables = Exact<{
  before: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type GetMyGymGoerNotificationsQuery = { __typename?: 'Query', getMyGymGoerNotifications?: { __typename?: 'GymGoerNotificationConnection', latestRead?: string | null | undefined, unreadCount?: number | null | undefined, nextToken?: string | null | undefined, items: Array<{ __typename?: 'GymGoerNotification', id: string, gymgoerId: string, type: GymGoerNotificationType, entityId?: string | null | undefined, created: string, title: string } | null | undefined> } | null | undefined };

export type MarkAllGymGoerNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllGymGoerNotificationsAsReadMutation = { __typename?: 'Mutation', markAllGymGoerNotificationsAsRead?: string | null | undefined };

export type GetMeGymGoerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeGymGoerQuery = { __typename?: 'Query', getMeGymGoer?: { __typename?: 'GymGoer', id: string, givenName: string, familyName?: string | null | undefined, displayName: string, email: string, mobileNumber?: string | null | undefined, profilePictureUrl?: string | null | undefined, gender?: Gender | null | undefined, keepDetailsInSync?: boolean | null | undefined, memberships?: Array<{ __typename?: 'GymGoerMembership', companyId: string, memberId: string, isDependent?: boolean | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RedeemMemberInviteMutationVariables = Exact<{
  id: Scalars['ID'];
  input: RedeemMemberInviteInput;
}>;


export type RedeemMemberInviteMutation = { __typename?: 'Mutation', redeemMemberInvite?: { __typename?: 'MemberInvite', companyName: string, createdByName: string, disabledAt?: string | null | undefined, email: string, expiresAt: string, givenName: string, id: string, memberId: string } | null | undefined };

export type GetMemberActiveMembershipQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetMemberActiveMembershipQuery = { __typename?: 'Query', getMemberActiveMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, directDebitProviderId?: string | null | undefined, paymentAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, visitLimit?: number | null | undefined, hasCustomFees: boolean, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined };

export type ChangePaymentFrequencyMutationVariables = Exact<{
  memberId: Scalars['ID'];
  paymentFrequency: MembershipPaymentFrequency;
}>;


export type ChangePaymentFrequencyMutation = { __typename?: 'Mutation', changePaymentFrequency?: { __typename?: 'MemberMembershipResponse', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, directDebitProviderId?: string | null | undefined, paymentAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, visitLimit?: number | null | undefined, hasCustomFees: boolean, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, error?: { __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined } | null | undefined };

export type CancelMyMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: CancelMyMembershipInput;
}>;


export type CancelMyMembershipMutation = { __typename?: 'Mutation', cancelMyMembership?: { __typename?: 'MembershipCancellationResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipCancellation?: { __typename?: 'MembershipCancellation', id: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, endDate: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type CancelMembershipCancellationMutationVariables = Exact<{
  memberId: Scalars['ID'];
  membershipCancellationId: Scalars['ID'];
}>;


export type CancelMembershipCancellationMutation = { __typename?: 'Mutation', cancelMembershipCancellation?: { __typename?: 'MembershipCancellationResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipCancellation?: { __typename?: 'MembershipCancellation', id: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, endDate: string } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipCancellationQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMembershipCancellationQuery = { __typename?: 'Query', getMembershipCancellation?: { __typename?: 'MembershipCancellation', id: string, cancellationFeeAmount?: number | null | undefined, cancelReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, endDate: string } | null | undefined };

export type SuspendMyMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: SuspendMyMembershipInput;
}>;


export type SuspendMyMembershipMutation = { __typename?: 'Mutation', suspendMyMembership?: { __typename?: 'MembershipSuspensionResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type StopMyMembershipSuspensionMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type StopMyMembershipSuspensionMutation = { __typename?: 'Mutation', stopMyMembershipSuspension?: { __typename?: 'MembershipSuspensionResult', memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined, membershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMembershipSuspensionQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMembershipSuspensionQuery = { __typename?: 'Query', getMembershipSuspension?: { __typename?: 'MembershipSuspension', id: string, suspensionFeeAmount?: number | null | undefined, suspendReason?: string | null | undefined, memberId: string, companyId: string, memberMembershipId: string, startDate: string, endDate: string, clubId?: string | null | undefined, requireApproval?: boolean | null | undefined, approvedAt?: string | null | undefined, deniedAt?: string | null | undefined, deniedReason?: string | null | undefined, handledByStaffId?: string | null | undefined } | null | undefined };

export type StartPublicMembershipSignUpMutationVariables = Exact<{
  input: StartPublicMembershipSignUpInput;
}>;


export type StartPublicMembershipSignUpMutation = { __typename?: 'Mutation', startPublicMembershipSignUp?: { __typename?: 'StartPublicMembershipSignUpResponse', success: boolean, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMemberQuery = { __typename?: 'Query', getMember?: { __typename?: 'Member', id: string, email: string, givenName: string, familyName?: string | null | undefined, displayName: string, mobileNumber?: string | null | undefined, status: MemberStatus, gender?: Gender | null | undefined, emailVerified?: boolean | null | undefined, address?: string | null | undefined, dateOfBirth?: string | null | undefined, profilePictureUrl?: string | null | undefined, activeMembershipId?: string | null | undefined, activeMemberMembershipId?: string | null | undefined, clubIds?: Array<string | null | undefined> | null | undefined, homeClubId: string, homeClubName: string, barcode?: string | null | undefined, dependantOf?: string | null | undefined, dependantIds?: Array<string> | null | undefined, amountOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined };

export type AgreeToCurrentMembershipMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: AgreeToMembershipInput;
}>;


export type AgreeToCurrentMembershipMutation = { __typename?: 'Mutation', agreeToCurrentMembership: { __typename?: 'MemberMembershipResponse', member?: { __typename?: 'Member', id: string, status: MemberStatus } | null | undefined, memberMembership?: { __typename?: 'MemberMembership', id: string, memberName: string, membershipName: string, memberId: string, membershipId: string, companyId: string, startDate: string, billingStartDate?: string | null | undefined, endDate?: string | null | undefined, paymentFrequency: MembershipPaymentFrequency, paymentAmount: number, visitLimit?: number | null | undefined, visitLimitFrequency?: LimitFrequency | null | undefined, lengthFrequency: MembershipLength, lengthAmount: number, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, dishonorFee?: number | null | undefined, hasCustomFees: boolean, membershipCancellationId?: string | null | undefined, membershipSuspensionId?: string | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, paidInFull?: boolean | null | undefined, initialDiscountPayments?: number | null | undefined, minimumAmountRemaining?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined, initialDiscountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined } | null | undefined } };

export type GetMemberChargesForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberChargesForMemberQuery = { __typename?: 'Query', getMemberChargesForMember?: { __typename?: 'MemberChargeConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined }> | null | undefined } | null | undefined };

export type GetMemberChargeQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMemberChargeQuery = { __typename?: 'Query', getMemberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined };

export type SettleMemberChargeMutationVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
}>;


export type SettleMemberChargeMutation = { __typename?: 'Mutation', settleMemberCharge?: { __typename?: 'MemberChargeResult', memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus, amountOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type SettleAccountMutationVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type SettleAccountMutation = { __typename?: 'Mutation', settleAccount?: { __typename?: 'MemberChargeResult', memberCharge?: { __typename?: 'MemberCharge', id: string, date: string, memberId: string, companyId: string, status: MemberChargeStatus, description?: string | null | undefined, serviceType: PaymentServiceType, servicePeriod?: string | null | undefined, serviceId: string, serviceAmount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, dishonorAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, totalOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, totalPaid?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, member?: { __typename?: 'Member', id: string, status: MemberStatus, amountOwed?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined }> | null | undefined } | null | undefined };

export type GetActivePaymentDetailsForMemberQueryVariables = Exact<{
  memberId: Scalars['ID'];
  paymentMethodType: PaymentMethodType;
}>;


export type GetActivePaymentDetailsForMemberQuery = { __typename?: 'Query', getActivePaymentDetailsForMember?: { __typename?: 'PaymentDetails', memberId: string, membershipId: string, directDebitProviderId: string, nextChargeDate: string, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number }, firstAmount: { __typename?: 'PaymentBreakdown', amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subTotal: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, transactionFee: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, merchantFee: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined }, regularAmount: { __typename?: 'ChargeAmount', frequency: MembershipPaymentFrequency, amount: { __typename?: 'PaymentBreakdown', amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subTotal: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, transactionFee: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, merchantFee: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined } }, memberFees: { __typename?: 'MemberFees', joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined }, transactionFees: { __typename?: 'TransactionFees', transactionFee?: number | null | undefined, merchantFeePercentage?: number | null | undefined, dishonorFee?: number | null | undefined } } | null | undefined };

export type GetScheduledMemberPaymentsForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  serviceType?: InputMaybe<PaymentServiceType>;
  clubId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  nextToken?: InputMaybe<Scalars['String']>;
}>;


export type GetScheduledMemberPaymentsForMemberQuery = { __typename?: 'Query', getScheduledMemberPaymentsForMember?: { __typename?: 'ScheduledMemberPaymentConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type GetMemberPaymentsForMemberQueryVariables = Exact<{
  memberId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['String']>;
}>;


export type GetMemberPaymentsForMemberQuery = { __typename?: 'Query', getMemberPaymentsForMember?: { __typename?: 'MemberPaymentConnection', nextToken?: string | null | undefined, items?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type ReprocessFailedMemberPaymentMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ReprocessFailedMemberPaymentMutation = { __typename?: 'Mutation', reprocessFailedMemberPayment?: { __typename?: 'MemberPaymentResult', memberPayment?: { __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetScheduledMemberPaymentsForChargeIdQueryVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
}>;


export type GetScheduledMemberPaymentsForChargeIdQuery = { __typename?: 'Query', getScheduledMemberPaymentsForChargeId?: Array<{ __typename?: 'ScheduledMemberPayment', id: string, memberId: string, companyId: string, scheduledAt: string, memberMembershipId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } }> | null | undefined };

export type GetMemberPaymentsForChargeIdQueryVariables = Exact<{
  memberId: Scalars['ID'];
  memberChargeId: Scalars['ID'];
}>;


export type GetMemberPaymentsForChargeIdQuery = { __typename?: 'Query', getMemberPaymentsForChargeId?: Array<{ __typename?: 'MemberPayment', id: string, memberId?: string | null | undefined, companyId: string, processedAt: string, memberPaymentMethodId?: string | null | undefined, status: PaymentStatus, failReason?: string | null | undefined, reprocessingFor?: string | null | undefined, reprocessedBy?: string | null | undefined, providerId?: string | null | undefined, membershipDays?: number | null | undefined, proRataDays?: number | null | undefined, serviceType: PaymentServiceType, serviceId: string, servicePeriod?: string | null | undefined, attemptNumber: number, invoiceId?: string | null | undefined, description?: string | null | undefined, memberChargeId?: string | null | undefined, proRataAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discountAmount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, transactionFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, merchantFee?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, subtotal?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, tax?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } }> | null | undefined };

export type GetMemberPaymentMethodsQueryVariables = Exact<{
  memberId: Scalars['ID'];
}>;


export type GetMemberPaymentMethodsQuery = { __typename?: 'Query', getMemberPaymentMethods?: Array<{ __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined> | null | undefined };

export type GetMemberPaymentMethodQueryVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetMemberPaymentMethodQuery = { __typename?: 'Query', getMemberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined };

export type AddMemberPaymentMethodMutationVariables = Exact<{
  memberId: Scalars['ID'];
  input: AddMemberPaymentMethodInput;
}>;


export type AddMemberPaymentMethodMutation = { __typename?: 'Mutation', addMemberPaymentMethod?: { __typename?: 'MemberPaymentMethodResult', memberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type RemoveMemberPaymentMethodMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type RemoveMemberPaymentMethodMutation = { __typename?: 'Mutation', removeMemberPaymentMethod?: { __typename?: 'MemberPaymentMethodResult', memberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type SetMemberPaymentMethodAsDefaultMutationVariables = Exact<{
  memberId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type SetMemberPaymentMethodAsDefaultMutation = { __typename?: 'Mutation', setMemberPaymentMethodAsDefault?: { __typename?: 'MemberPaymentMethodResult', memberPaymentMethod?: { __typename?: 'MemberPaymentMethod', id: string, isDefault: boolean, memberId: string, companyId: string, type: PaymentMethodType, providerId: string, maskedNumber: string, expiryMonth?: string | null | undefined, expiryYear?: string | null | undefined, accountName?: string | null | undefined } | null | undefined, errors?: Array<{ __typename?: 'Error', type?: string | null | undefined, message?: string | null | undefined } | null | undefined> | null | undefined } | null | undefined };

export type GetAmountForMembershipFrequencyQueryVariables = Exact<{
  id: Scalars['ID'];
  paymentFrequency: MembershipPaymentFrequency;
}>;


export type GetAmountForMembershipFrequencyQuery = { __typename?: 'Query', getAmountForMembershipFrequency?: { __typename?: 'MembershipAmountsResponse', membershipAmount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } }, suspensionFee: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', code: string, base: number, exponent: number } } } | null | undefined };

export type GetMembershipQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMembershipQuery = { __typename?: 'Query', getMembership?: { __typename?: 'Membership', availablePaymentPeriods?: Array<MembershipPaymentFrequency | null | undefined> | null | undefined, description?: string | null | undefined, id: string, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, name: string, paymentAmount?: number | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, paidInFullOnly?: boolean | null | undefined, availableToPublic?: boolean | null | undefined, order?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, initialDiscountPayments?: number | null | undefined, initialDiscountPercentage?: number | null | undefined, payInFullOptions?: Array<{ __typename?: 'PayInFullOption', months: number, amount: number }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetPublicMembershipsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetPublicMembershipsQuery = { __typename?: 'Query', getPublicMemberships?: Array<{ __typename?: 'Membership', id: string, name: string, description?: string | null | undefined, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentFrequency?: MembershipPaymentFrequency | null | undefined, paymentAmount?: number | null | undefined, availablePaymentPeriods?: Array<MembershipPaymentFrequency | null | undefined> | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, cancellationFee?: number | null | undefined, suspensionFee?: number | null | undefined, allowPaidInFull?: boolean | null | undefined, paidInFullOnly?: boolean | null | undefined, availableToPublic?: boolean | null | undefined, order?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, payInFullOptions?: Array<{ __typename?: 'PayInFullOption', months: number, amount: number }> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined };

export type GetMyNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyNotificationPreferencesQuery = { __typename?: 'Query', getMyNotificationPreferences?: { __typename?: 'NotificationPreferences', classCancelled?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, classTimeChanged?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, classWaitlistAvailable?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, classBooked?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, paymentFailed?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, paymentSucceeded?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined } | null | undefined };

export type UpdateNotificationPreferencesMutationVariables = Exact<{
  input: UpdateNotificationPreferencesInput;
}>;


export type UpdateNotificationPreferencesMutation = { __typename?: 'Mutation', updateNotificationPreferences?: { __typename?: 'NotificationPreferences', classCancelled?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, classTimeChanged?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, classWaitlistAvailable?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, classBooked?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, paymentFailed?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined, paymentSucceeded?: { __typename?: 'NotificationPreferencesOptions', email?: boolean | null | undefined, sms?: boolean | null | undefined, push?: boolean | null | undefined } | null | undefined } | null | undefined };

export type GetOrderByInvoiceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  clubId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetOrderByInvoiceQuery = { __typename?: 'Query', getOrderByInvoice?: { __typename?: 'PublicOrderResponse', order?: { __typename?: 'Order', id: string, companyId: string, status: OrderStatus, created: string, memberName?: string | null | undefined, clubId: string, discountPercentage?: number | null | undefined, memberPaymentId?: string | null | undefined, totalQuantity: number, invoiceId: string, refundReason?: string | null | undefined, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, subtotal: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, tax: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, discount?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, currency: { __typename?: 'Currency', base: number, code: string, exponent: number }, paid?: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } | null | undefined, outstanding: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined, orderItems?: Array<{ __typename?: 'OrderItem', id: string, orderId: string, companyId: string, memberId?: string | null | undefined, clubId: string, productId: string, productStockId: string, quantity: number, amount: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } }, total: { __typename?: 'Money', amount: any, scale: number, currency: { __typename?: 'Currency', base: number, code: string, exponent: number } } } | null | undefined> | null | undefined } | null | undefined };

export type GetPackagelQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPackagelQuery = { __typename?: 'Query', getPackage?: { __typename?: 'Package', id: string, name: string, description?: string | null | undefined, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount?: number | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetPublicPackagesQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetPublicPackagesQuery = { __typename?: 'Query', getPublicPackages?: Array<{ __typename?: 'Package', id: string, name: string, description?: string | null | undefined, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount?: number | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined };

export type PublicSearchQueryVariables = Exact<{
  input: PublicSearchInput;
}>;


export type PublicSearchQuery = { __typename?: 'Query', publicSearch?: { __typename?: 'PublicSearchResult', page: number, pageCount: number, perPage: number, resultCount: number, items: Array<{ __typename?: 'PublicSearchResultItem', id: string, title: string, detail?: string | null | undefined, thumbnailUrl?: string | null | undefined, type: PublicSearchDocumentType, address?: string | null | undefined } | null | undefined> } | null | undefined };

export type GetTrialQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTrialQuery = { __typename?: 'Query', getTrial?: { __typename?: 'Trial', id: string, name: string, description?: string | null | undefined, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount?: number | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined };

export type GetPublicTrialsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetPublicTrialsQuery = { __typename?: 'Query', getPublicTrials?: Array<{ __typename?: 'Trial', id: string, name: string, description?: string | null | undefined, publishedAt?: string | null | undefined, thumbnailImageUrl?: string | null | undefined, paymentAmount?: number | null | undefined, lengthAmount?: number | null | undefined, lengthFrequency?: MembershipLength | null | undefined, joinFee?: number | null | undefined, adminFee?: number | null | undefined, fobFee?: number | null | undefined, restrictedClassTypeIds?: Array<string | null | undefined> | null | undefined, baseCurrency: { __typename?: 'Currency', code: string, base: number, exponent: number } } | null | undefined> | null | undefined };


export const SearchForAddressDocument = gql`
    query searchForAddress($search: String!) {
  searchForAddress(search: $search) {
    items {
      fullText
      address
      streetOne
      streetTwo
      city
      zipPostcode
      state
      country
      center
    }
  }
}
    `;

/**
 * __useSearchForAddressQuery__
 *
 * To run a query within a React component, call `useSearchForAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchForAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchForAddressQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchForAddressQuery(baseOptions: Apollo.QueryHookOptions<SearchForAddressQuery, SearchForAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchForAddressQuery, SearchForAddressQueryVariables>(SearchForAddressDocument, options);
      }
export function useSearchForAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchForAddressQuery, SearchForAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchForAddressQuery, SearchForAddressQueryVariables>(SearchForAddressDocument, options);
        }
export type SearchForAddressQueryHookResult = ReturnType<typeof useSearchForAddressQuery>;
export type SearchForAddressLazyQueryHookResult = ReturnType<typeof useSearchForAddressLazyQuery>;
export type SearchForAddressQueryResult = Apollo.QueryResult<SearchForAddressQuery, SearchForAddressQueryVariables>;
export const BookMemberIntoClassDocument = gql`
    mutation bookMemberIntoClass($classId: String!, $memberId: String!) {
  bookMemberIntoClass(classId: $classId, memberId: $memberId) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
      lateCancellationWindow
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type BookMemberIntoClassMutationFn = Apollo.MutationFunction<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>;

/**
 * __useBookMemberIntoClassMutation__
 *
 * To run a mutation, you first call `useBookMemberIntoClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMemberIntoClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMemberIntoClassMutation, { data, loading, error }] = useBookMemberIntoClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBookMemberIntoClassMutation(baseOptions?: Apollo.MutationHookOptions<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>(BookMemberIntoClassDocument, options);
      }
export type BookMemberIntoClassMutationHookResult = ReturnType<typeof useBookMemberIntoClassMutation>;
export type BookMemberIntoClassMutationResult = Apollo.MutationResult<BookMemberIntoClassMutation>;
export type BookMemberIntoClassMutationOptions = Apollo.BaseMutationOptions<BookMemberIntoClassMutation, BookMemberIntoClassMutationVariables>;
export const CancelClassBookingDocument = gql`
    mutation cancelClassBooking($classId: String!, $memberId: String!, $cancellationReason: String) {
  cancelClassBooking(
    classId: $classId
    memberId: $memberId
    cancellationReason: $cancellationReason
  ) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      className
      checkedInAt
      startsAt
      lateCancellationWindow
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassBookingMutationFn = Apollo.MutationFunction<CancelClassBookingMutation, CancelClassBookingMutationVariables>;

/**
 * __useCancelClassBookingMutation__
 *
 * To run a mutation, you first call `useCancelClassBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassBookingMutation, { data, loading, error }] = useCancelClassBookingMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *      cancellationReason: // value for 'cancellationReason'
 *   },
 * });
 */
export function useCancelClassBookingMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassBookingMutation, CancelClassBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassBookingMutation, CancelClassBookingMutationVariables>(CancelClassBookingDocument, options);
      }
export type CancelClassBookingMutationHookResult = ReturnType<typeof useCancelClassBookingMutation>;
export type CancelClassBookingMutationResult = Apollo.MutationResult<CancelClassBookingMutation>;
export type CancelClassBookingMutationOptions = Apollo.BaseMutationOptions<CancelClassBookingMutation, CancelClassBookingMutationVariables>;
export const BookMemberIntoWaitlistDocument = gql`
    mutation bookMemberIntoWaitlist($classId: String!, $memberId: String!) {
  bookMemberIntoWaitlist(classId: $classId, memberId: $memberId) {
    classWaitlist {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type BookMemberIntoWaitlistMutationFn = Apollo.MutationFunction<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>;

/**
 * __useBookMemberIntoWaitlistMutation__
 *
 * To run a mutation, you first call `useBookMemberIntoWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMemberIntoWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMemberIntoWaitlistMutation, { data, loading, error }] = useBookMemberIntoWaitlistMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBookMemberIntoWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>(BookMemberIntoWaitlistDocument, options);
      }
export type BookMemberIntoWaitlistMutationHookResult = ReturnType<typeof useBookMemberIntoWaitlistMutation>;
export type BookMemberIntoWaitlistMutationResult = Apollo.MutationResult<BookMemberIntoWaitlistMutation>;
export type BookMemberIntoWaitlistMutationOptions = Apollo.BaseMutationOptions<BookMemberIntoWaitlistMutation, BookMemberIntoWaitlistMutationVariables>;
export const CancelClassWaitlistDocument = gql`
    mutation cancelClassWaitlist($classId: String!, $memberId: String!) {
  cancelClassWaitlist(classId: $classId, memberId: $memberId) {
    classWaitlist {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassWaitlistMutationFn = Apollo.MutationFunction<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>;

/**
 * __useCancelClassWaitlistMutation__
 *
 * To run a mutation, you first call `useCancelClassWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassWaitlistMutation, { data, loading, error }] = useCancelClassWaitlistMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCancelClassWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>(CancelClassWaitlistDocument, options);
      }
export type CancelClassWaitlistMutationHookResult = ReturnType<typeof useCancelClassWaitlistMutation>;
export type CancelClassWaitlistMutationResult = Apollo.MutationResult<CancelClassWaitlistMutation>;
export type CancelClassWaitlistMutationOptions = Apollo.BaseMutationOptions<CancelClassWaitlistMutation, CancelClassWaitlistMutationVariables>;
export const ConfirmClassWaitlistDocument = gql`
    mutation confirmClassWaitlist($classId: String!, $memberId: String!) {
  confirmClassWaitlist(classId: $classId, memberId: $memberId) {
    classWaitlist {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      className
      checkedInAt
      startsAt
      lateCancellationWindow
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ConfirmClassWaitlistMutationFn = Apollo.MutationFunction<ConfirmClassWaitlistMutation, ConfirmClassWaitlistMutationVariables>;

/**
 * __useConfirmClassWaitlistMutation__
 *
 * To run a mutation, you first call `useConfirmClassWaitlistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmClassWaitlistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmClassWaitlistMutation, { data, loading, error }] = useConfirmClassWaitlistMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useConfirmClassWaitlistMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmClassWaitlistMutation, ConfirmClassWaitlistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmClassWaitlistMutation, ConfirmClassWaitlistMutationVariables>(ConfirmClassWaitlistDocument, options);
      }
export type ConfirmClassWaitlistMutationHookResult = ReturnType<typeof useConfirmClassWaitlistMutation>;
export type ConfirmClassWaitlistMutationResult = Apollo.MutationResult<ConfirmClassWaitlistMutation>;
export type ConfirmClassWaitlistMutationOptions = Apollo.BaseMutationOptions<ConfirmClassWaitlistMutation, ConfirmClassWaitlistMutationVariables>;
export const CheckInMemberForClassDocument = gql`
    mutation checkInMemberForClass($classId: String!, $memberId: String!) {
  checkInMemberForClass(classId: $classId, memberId: $memberId) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
      lateCancellationWindow
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CheckInMemberForClassMutationFn = Apollo.MutationFunction<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>;

/**
 * __useCheckInMemberForClassMutation__
 *
 * To run a mutation, you first call `useCheckInMemberForClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInMemberForClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInMemberForClassMutation, { data, loading, error }] = useCheckInMemberForClassMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCheckInMemberForClassMutation(baseOptions?: Apollo.MutationHookOptions<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>(CheckInMemberForClassDocument, options);
      }
export type CheckInMemberForClassMutationHookResult = ReturnType<typeof useCheckInMemberForClassMutation>;
export type CheckInMemberForClassMutationResult = Apollo.MutationResult<CheckInMemberForClassMutation>;
export type CheckInMemberForClassMutationOptions = Apollo.BaseMutationOptions<CheckInMemberForClassMutation, CheckInMemberForClassMutationVariables>;
export const CancelClassCheckInDocument = gql`
    mutation cancelClassCheckIn($classId: String!, $memberId: String!) {
  cancelClassCheckIn(classId: $classId, memberId: $memberId) {
    classBooking {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
      lateCancellationWindow
    }
    class {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelClassCheckInMutationFn = Apollo.MutationFunction<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>;

/**
 * __useCancelClassCheckInMutation__
 *
 * To run a mutation, you first call `useCancelClassCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelClassCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelClassCheckInMutation, { data, loading, error }] = useCancelClassCheckInMutation({
 *   variables: {
 *      classId: // value for 'classId'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useCancelClassCheckInMutation(baseOptions?: Apollo.MutationHookOptions<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>(CancelClassCheckInDocument, options);
      }
export type CancelClassCheckInMutationHookResult = ReturnType<typeof useCancelClassCheckInMutation>;
export type CancelClassCheckInMutationResult = Apollo.MutationResult<CancelClassCheckInMutation>;
export type CancelClassCheckInMutationOptions = Apollo.BaseMutationOptions<CancelClassCheckInMutation, CancelClassCheckInMutationVariables>;
export const GetClassBookingsForMemberDocument = gql`
    query getClassBookingsForMember($memberId: String!, $startsAt: String!, $limit: Int, $nextToken: String) {
  getClassBookingsForMember(
    memberId: $memberId
    startsAt: $startsAt
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      classId
      bookedOn
      cancelledAt
      cancellationReason
      checkedInAt
      className
      startsAt
      lateCancellationWindow
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassBookingsForMemberQuery__
 *
 * To run a query within a React component, call `useGetClassBookingsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassBookingsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassBookingsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetClassBookingsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>(GetClassBookingsForMemberDocument, options);
      }
export function useGetClassBookingsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>(GetClassBookingsForMemberDocument, options);
        }
export type GetClassBookingsForMemberQueryHookResult = ReturnType<typeof useGetClassBookingsForMemberQuery>;
export type GetClassBookingsForMemberLazyQueryHookResult = ReturnType<typeof useGetClassBookingsForMemberLazyQuery>;
export type GetClassBookingsForMemberQueryResult = Apollo.QueryResult<GetClassBookingsForMemberQuery, GetClassBookingsForMemberQueryVariables>;
export const GetClassWaitlistForMemberDocument = gql`
    query getClassWaitlistForMember($memberId: String!, $startsAt: String!, $limit: Int, $nextToken: String) {
  getClassWaitlistForMember(
    memberId: $memberId
    startsAt: $startsAt
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      classId
      waitedOn
      className
      startsAt
      lockedUntil
      expiredOn
      confirmedOn
    }
    nextToken
  }
}
    `;

/**
 * __useGetClassWaitlistForMemberQuery__
 *
 * To run a query within a React component, call `useGetClassWaitlistForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClassWaitlistForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClassWaitlistForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      startsAt: // value for 'startsAt'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetClassWaitlistForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>(GetClassWaitlistForMemberDocument, options);
      }
export function useGetClassWaitlistForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>(GetClassWaitlistForMemberDocument, options);
        }
export type GetClassWaitlistForMemberQueryHookResult = ReturnType<typeof useGetClassWaitlistForMemberQuery>;
export type GetClassWaitlistForMemberLazyQueryHookResult = ReturnType<typeof useGetClassWaitlistForMemberLazyQuery>;
export type GetClassWaitlistForMemberQueryResult = Apollo.QueryResult<GetClassWaitlistForMemberQuery, GetClassWaitlistForMemberQueryVariables>;
export const GetPublicClassesDocument = gql`
    query getPublicClasses($clubId: String!, $companyId: String!, $startsAt: String!, $staffIds: [String], $classTypeIds: [String], $endsAt: String, $limit: Int, $memberId: String) {
  getPublicClasses(
    clubId: $clubId
    companyId: $companyId
    startsAt: $startsAt
    staffIds: $staffIds
    classTypeIds: $classTypeIds
    endsAt: $endsAt
    limit: $limit
    memberId: $memberId
  ) {
    items {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubId
      staffId
      staffName
      startsAt
      length
      maximumCapacity
      currentCapacity
      useWaitlist
      useCheckIn
      cancelledAt
      cancellationReason
      waitlistConfirmationWindow
      bookedIn
      currentlyWaiting
      lateCancellationWindow
      lateCancellationCost
      noShowCost
      bookingWindow
    }
    nextToken
  }
}
    `;

/**
 * __useGetPublicClassesQuery__
 *
 * To run a query within a React component, call `useGetPublicClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicClassesQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *      companyId: // value for 'companyId'
 *      startsAt: // value for 'startsAt'
 *      staffIds: // value for 'staffIds'
 *      classTypeIds: // value for 'classTypeIds'
 *      endsAt: // value for 'endsAt'
 *      limit: // value for 'limit'
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetPublicClassesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicClassesQuery, GetPublicClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicClassesQuery, GetPublicClassesQueryVariables>(GetPublicClassesDocument, options);
      }
export function useGetPublicClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicClassesQuery, GetPublicClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicClassesQuery, GetPublicClassesQueryVariables>(GetPublicClassesDocument, options);
        }
export type GetPublicClassesQueryHookResult = ReturnType<typeof useGetPublicClassesQuery>;
export type GetPublicClassesLazyQueryHookResult = ReturnType<typeof useGetPublicClassesLazyQuery>;
export type GetPublicClassesQueryResult = Apollo.QueryResult<GetPublicClassesQuery, GetPublicClassesQueryVariables>;
export const GetPublicClassTypesDocument = gql`
    query getPublicClassTypes($companyId: String!, $limit: Int, $nextToken: String, $clubId: String) {
  getPublicClassTypes(
    companyId: $companyId
    limit: $limit
    nextToken: $nextToken
    clubId: $clubId
  ) {
    items {
      id
      name
      description
      thumbnailImageUrl
      companyId
      clubIds
    }
    nextToken
  }
}
    `;

/**
 * __useGetPublicClassTypesQuery__
 *
 * To run a query within a React component, call `useGetPublicClassTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicClassTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicClassTypesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetPublicClassTypesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicClassTypesQuery, GetPublicClassTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicClassTypesQuery, GetPublicClassTypesQueryVariables>(GetPublicClassTypesDocument, options);
      }
export function useGetPublicClassTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicClassTypesQuery, GetPublicClassTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicClassTypesQuery, GetPublicClassTypesQueryVariables>(GetPublicClassTypesDocument, options);
        }
export type GetPublicClassTypesQueryHookResult = ReturnType<typeof useGetPublicClassTypesQuery>;
export type GetPublicClassTypesLazyQueryHookResult = ReturnType<typeof useGetPublicClassTypesLazyQuery>;
export type GetPublicClassTypesQueryResult = Apollo.QueryResult<GetPublicClassTypesQuery, GetPublicClassTypesQueryVariables>;
export const GetMyMemberClubsDocument = gql`
    query getMyMemberClubs {
  getMyMemberClubs {
    items {
      id
      name
      clubId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMyMemberClubsQuery__
 *
 * To run a query within a React component, call `useGetMyMemberClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMemberClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMemberClubsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyMemberClubsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMemberClubsQuery, GetMyMemberClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMemberClubsQuery, GetMyMemberClubsQueryVariables>(GetMyMemberClubsDocument, options);
      }
export function useGetMyMemberClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMemberClubsQuery, GetMyMemberClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMemberClubsQuery, GetMyMemberClubsQueryVariables>(GetMyMemberClubsDocument, options);
        }
export type GetMyMemberClubsQueryHookResult = ReturnType<typeof useGetMyMemberClubsQuery>;
export type GetMyMemberClubsLazyQueryHookResult = ReturnType<typeof useGetMyMemberClubsLazyQuery>;
export type GetMyMemberClubsQueryResult = Apollo.QueryResult<GetMyMemberClubsQuery, GetMyMemberClubsQueryVariables>;
export const GetClubDocument = gql`
    query getClub($id: ID!) {
  getClub(id: $id) {
    id
    name
    description
    address
    pricesIncludeTax
    timezone
    countryCode
    taxNumber
    contactNumber
    baseCurrency {
      base
      code
      exponent
    }
    clubWebPortal {
      allowCancellation
      allowPaymentFrequencyUpdate
      allowPublicSignUp
      allowSuspension
      backgroundColor
      buttonBackgroundColor
      buttonTextColor
      clubId
      enabled
      logInText
      maximumSuspensionDays
      minimumSuspensionDays
      showPublicClasses
      textColor
      welcomeText
      classTitle
      showBarcode
      showClassAvailability
      allowSuspensionRequest
    }
    company {
      id
      logoImageUrl
      coverImageUrl
      name
      description
      termsAndConditionsUrl
      websiteUrl
    }
  }
}
    `;

/**
 * __useGetClubQuery__
 *
 * To run a query within a React component, call `useGetClubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClubQuery(baseOptions: Apollo.QueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
      }
export function useGetClubLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubQuery, GetClubQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubQuery, GetClubQueryVariables>(GetClubDocument, options);
        }
export type GetClubQueryHookResult = ReturnType<typeof useGetClubQuery>;
export type GetClubLazyQueryHookResult = ReturnType<typeof useGetClubLazyQuery>;
export type GetClubQueryResult = Apollo.QueryResult<GetClubQuery, GetClubQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    description
    termsAndConditionsUrl
    logoImageUrl
    coverImageUrl
    websiteUrl
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyMemberRequiredFieldsDocument = gql`
    query getCompanyMemberRequiredFields($id: ID!) {
  getCompanyMemberRequiredFields(id: $id) {
    companyId
    firstName
    lastName
    email
    dateOfBirth
    mobile
    address
    barcode
  }
}
    `;

/**
 * __useGetCompanyMemberRequiredFieldsQuery__
 *
 * To run a query within a React component, call `useGetCompanyMemberRequiredFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyMemberRequiredFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyMemberRequiredFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyMemberRequiredFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>(GetCompanyMemberRequiredFieldsDocument, options);
      }
export function useGetCompanyMemberRequiredFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>(GetCompanyMemberRequiredFieldsDocument, options);
        }
export type GetCompanyMemberRequiredFieldsQueryHookResult = ReturnType<typeof useGetCompanyMemberRequiredFieldsQuery>;
export type GetCompanyMemberRequiredFieldsLazyQueryHookResult = ReturnType<typeof useGetCompanyMemberRequiredFieldsLazyQuery>;
export type GetCompanyMemberRequiredFieldsQueryResult = Apollo.QueryResult<GetCompanyMemberRequiredFieldsQuery, GetCompanyMemberRequiredFieldsQueryVariables>;
export const GetDirectDebitProviderDocument = gql`
    query getDirectDebitProvider($id: ID!) {
  getDirectDebitProvider(id: $id) {
    id
    name
    description
    url
    logoUrl
    termsAndConditionsUrl
    baseCurrency {
      code
      base
      exponent
    }
  }
}
    `;

/**
 * __useGetDirectDebitProviderQuery__
 *
 * To run a query within a React component, call `useGetDirectDebitProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectDebitProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectDebitProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDirectDebitProviderQuery(baseOptions: Apollo.QueryHookOptions<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>(GetDirectDebitProviderDocument, options);
      }
export function useGetDirectDebitProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>(GetDirectDebitProviderDocument, options);
        }
export type GetDirectDebitProviderQueryHookResult = ReturnType<typeof useGetDirectDebitProviderQuery>;
export type GetDirectDebitProviderLazyQueryHookResult = ReturnType<typeof useGetDirectDebitProviderLazyQuery>;
export type GetDirectDebitProviderQueryResult = Apollo.QueryResult<GetDirectDebitProviderQuery, GetDirectDebitProviderQueryVariables>;
export const GetMemberFileUploadUrlDocument = gql`
    query getMemberFileUploadUrl($memberId: ID!, $uploadFileType: PublicUploadFileType!, $fileType: String!, $entityId: ID, $index: Int) {
  getMemberFileUploadUrl(
    memberId: $memberId
    uploadFileType: $uploadFileType
    fileType: $fileType
    entityId: $entityId
    index: $index
  ) {
    uploadUrl
    getUrl
  }
}
    `;

/**
 * __useGetMemberFileUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetMemberFileUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberFileUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberFileUploadUrlQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      uploadFileType: // value for 'uploadFileType'
 *      fileType: // value for 'fileType'
 *      entityId: // value for 'entityId'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useGetMemberFileUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<GetMemberFileUploadUrlQuery, GetMemberFileUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberFileUploadUrlQuery, GetMemberFileUploadUrlQueryVariables>(GetMemberFileUploadUrlDocument, options);
      }
export function useGetMemberFileUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberFileUploadUrlQuery, GetMemberFileUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberFileUploadUrlQuery, GetMemberFileUploadUrlQueryVariables>(GetMemberFileUploadUrlDocument, options);
        }
export type GetMemberFileUploadUrlQueryHookResult = ReturnType<typeof useGetMemberFileUploadUrlQuery>;
export type GetMemberFileUploadUrlLazyQueryHookResult = ReturnType<typeof useGetMemberFileUploadUrlLazyQuery>;
export type GetMemberFileUploadUrlQueryResult = Apollo.QueryResult<GetMemberFileUploadUrlQuery, GetMemberFileUploadUrlQueryVariables>;
export const GetMyGymGoerNotificationsDocument = gql`
    query getMyGymGoerNotifications($before: String!, $limit: Int) {
  getMyGymGoerNotifications(before: $before, limit: $limit) {
    items {
      id
      gymgoerId
      type
      entityId
      created
      title
    }
    latestRead
    unreadCount
    nextToken
  }
}
    `;

/**
 * __useGetMyGymGoerNotificationsQuery__
 *
 * To run a query within a React component, call `useGetMyGymGoerNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGymGoerNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGymGoerNotificationsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMyGymGoerNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetMyGymGoerNotificationsQuery, GetMyGymGoerNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGymGoerNotificationsQuery, GetMyGymGoerNotificationsQueryVariables>(GetMyGymGoerNotificationsDocument, options);
      }
export function useGetMyGymGoerNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGymGoerNotificationsQuery, GetMyGymGoerNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGymGoerNotificationsQuery, GetMyGymGoerNotificationsQueryVariables>(GetMyGymGoerNotificationsDocument, options);
        }
export type GetMyGymGoerNotificationsQueryHookResult = ReturnType<typeof useGetMyGymGoerNotificationsQuery>;
export type GetMyGymGoerNotificationsLazyQueryHookResult = ReturnType<typeof useGetMyGymGoerNotificationsLazyQuery>;
export type GetMyGymGoerNotificationsQueryResult = Apollo.QueryResult<GetMyGymGoerNotificationsQuery, GetMyGymGoerNotificationsQueryVariables>;
export const MarkAllGymGoerNotificationsAsReadDocument = gql`
    mutation markAllGymGoerNotificationsAsRead {
  markAllGymGoerNotificationsAsRead
}
    `;
export type MarkAllGymGoerNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllGymGoerNotificationsAsReadMutation, MarkAllGymGoerNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllGymGoerNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllGymGoerNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllGymGoerNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllGymGoerNotificationsAsReadMutation, { data, loading, error }] = useMarkAllGymGoerNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllGymGoerNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllGymGoerNotificationsAsReadMutation, MarkAllGymGoerNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllGymGoerNotificationsAsReadMutation, MarkAllGymGoerNotificationsAsReadMutationVariables>(MarkAllGymGoerNotificationsAsReadDocument, options);
      }
export type MarkAllGymGoerNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllGymGoerNotificationsAsReadMutation>;
export type MarkAllGymGoerNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllGymGoerNotificationsAsReadMutation>;
export type MarkAllGymGoerNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllGymGoerNotificationsAsReadMutation, MarkAllGymGoerNotificationsAsReadMutationVariables>;
export const GetMeGymGoerDocument = gql`
    query getMeGymGoer {
  getMeGymGoer {
    id
    givenName
    familyName
    displayName
    email
    mobileNumber
    profilePictureUrl
    gender
    keepDetailsInSync
    memberships {
      companyId
      memberId
      isDependent
    }
  }
}
    `;

/**
 * __useGetMeGymGoerQuery__
 *
 * To run a query within a React component, call `useGetMeGymGoerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeGymGoerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeGymGoerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeGymGoerQuery(baseOptions?: Apollo.QueryHookOptions<GetMeGymGoerQuery, GetMeGymGoerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeGymGoerQuery, GetMeGymGoerQueryVariables>(GetMeGymGoerDocument, options);
      }
export function useGetMeGymGoerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeGymGoerQuery, GetMeGymGoerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeGymGoerQuery, GetMeGymGoerQueryVariables>(GetMeGymGoerDocument, options);
        }
export type GetMeGymGoerQueryHookResult = ReturnType<typeof useGetMeGymGoerQuery>;
export type GetMeGymGoerLazyQueryHookResult = ReturnType<typeof useGetMeGymGoerLazyQuery>;
export type GetMeGymGoerQueryResult = Apollo.QueryResult<GetMeGymGoerQuery, GetMeGymGoerQueryVariables>;
export const RedeemMemberInviteDocument = gql`
    mutation redeemMemberInvite($id: ID!, $input: RedeemMemberInviteInput!) {
  redeemMemberInvite(id: $id, input: $input) {
    companyName
    createdByName
    disabledAt
    email
    expiresAt
    givenName
    id
    memberId
  }
}
    `;
export type RedeemMemberInviteMutationFn = Apollo.MutationFunction<RedeemMemberInviteMutation, RedeemMemberInviteMutationVariables>;

/**
 * __useRedeemMemberInviteMutation__
 *
 * To run a mutation, you first call `useRedeemMemberInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemMemberInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemMemberInviteMutation, { data, loading, error }] = useRedeemMemberInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRedeemMemberInviteMutation(baseOptions?: Apollo.MutationHookOptions<RedeemMemberInviteMutation, RedeemMemberInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemMemberInviteMutation, RedeemMemberInviteMutationVariables>(RedeemMemberInviteDocument, options);
      }
export type RedeemMemberInviteMutationHookResult = ReturnType<typeof useRedeemMemberInviteMutation>;
export type RedeemMemberInviteMutationResult = Apollo.MutationResult<RedeemMemberInviteMutation>;
export type RedeemMemberInviteMutationOptions = Apollo.BaseMutationOptions<RedeemMemberInviteMutation, RedeemMemberInviteMutationVariables>;
export const GetMemberActiveMembershipDocument = gql`
    query getMemberActiveMembership($memberId: ID!) {
  getMemberActiveMembership(memberId: $memberId) {
    id
    memberName
    membershipName
    memberId
    membershipId
    companyId
    startDate
    endDate
    paymentFrequency
    directDebitProviderId
    paymentAmount
    minimumAmountRemaining {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    dishonorFee
    visitLimit
    hasCustomFees
    visitLimitFrequency
    lengthFrequency
    lengthAmount
    membershipCancellationId
    membershipSuspensionId
    restrictedClassTypeIds
    paidInFull
    initialDiscountAmount {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
    initialDiscountPayments
  }
}
    `;

/**
 * __useGetMemberActiveMembershipQuery__
 *
 * To run a query within a React component, call `useGetMemberActiveMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberActiveMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberActiveMembershipQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberActiveMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>(GetMemberActiveMembershipDocument, options);
      }
export function useGetMemberActiveMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>(GetMemberActiveMembershipDocument, options);
        }
export type GetMemberActiveMembershipQueryHookResult = ReturnType<typeof useGetMemberActiveMembershipQuery>;
export type GetMemberActiveMembershipLazyQueryHookResult = ReturnType<typeof useGetMemberActiveMembershipLazyQuery>;
export type GetMemberActiveMembershipQueryResult = Apollo.QueryResult<GetMemberActiveMembershipQuery, GetMemberActiveMembershipQueryVariables>;
export const ChangePaymentFrequencyDocument = gql`
    mutation changePaymentFrequency($memberId: ID!, $paymentFrequency: MembershipPaymentFrequency!) {
  changePaymentFrequency(memberId: $memberId, paymentFrequency: $paymentFrequency) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      directDebitProviderId
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      visitLimit
      hasCustomFees
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    error {
      type
      message
    }
  }
}
    `;
export type ChangePaymentFrequencyMutationFn = Apollo.MutationFunction<ChangePaymentFrequencyMutation, ChangePaymentFrequencyMutationVariables>;

/**
 * __useChangePaymentFrequencyMutation__
 *
 * To run a mutation, you first call `useChangePaymentFrequencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePaymentFrequencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePaymentFrequencyMutation, { data, loading, error }] = useChangePaymentFrequencyMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      paymentFrequency: // value for 'paymentFrequency'
 *   },
 * });
 */
export function useChangePaymentFrequencyMutation(baseOptions?: Apollo.MutationHookOptions<ChangePaymentFrequencyMutation, ChangePaymentFrequencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePaymentFrequencyMutation, ChangePaymentFrequencyMutationVariables>(ChangePaymentFrequencyDocument, options);
      }
export type ChangePaymentFrequencyMutationHookResult = ReturnType<typeof useChangePaymentFrequencyMutation>;
export type ChangePaymentFrequencyMutationResult = Apollo.MutationResult<ChangePaymentFrequencyMutation>;
export type ChangePaymentFrequencyMutationOptions = Apollo.BaseMutationOptions<ChangePaymentFrequencyMutation, ChangePaymentFrequencyMutationVariables>;
export const CancelMyMembershipDocument = gql`
    mutation cancelMyMembership($memberId: ID!, $input: CancelMyMembershipInput!) {
  cancelMyMembership(memberId: $memberId, input: $input) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipCancellation {
      id
      cancellationFeeAmount
      cancelReason
      memberId
      companyId
      memberMembershipId
      endDate
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelMyMembershipMutationFn = Apollo.MutationFunction<CancelMyMembershipMutation, CancelMyMembershipMutationVariables>;

/**
 * __useCancelMyMembershipMutation__
 *
 * To run a mutation, you first call `useCancelMyMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMyMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMyMembershipMutation, { data, loading, error }] = useCancelMyMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelMyMembershipMutation(baseOptions?: Apollo.MutationHookOptions<CancelMyMembershipMutation, CancelMyMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMyMembershipMutation, CancelMyMembershipMutationVariables>(CancelMyMembershipDocument, options);
      }
export type CancelMyMembershipMutationHookResult = ReturnType<typeof useCancelMyMembershipMutation>;
export type CancelMyMembershipMutationResult = Apollo.MutationResult<CancelMyMembershipMutation>;
export type CancelMyMembershipMutationOptions = Apollo.BaseMutationOptions<CancelMyMembershipMutation, CancelMyMembershipMutationVariables>;
export const CancelMembershipCancellationDocument = gql`
    mutation cancelMembershipCancellation($memberId: ID!, $membershipCancellationId: ID!) {
  cancelMembershipCancellation(
    memberId: $memberId
    membershipCancellationId: $membershipCancellationId
  ) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipCancellation {
      id
      cancellationFeeAmount
      cancelReason
      memberId
      companyId
      memberMembershipId
      endDate
    }
    errors {
      type
      message
    }
  }
}
    `;
export type CancelMembershipCancellationMutationFn = Apollo.MutationFunction<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>;

/**
 * __useCancelMembershipCancellationMutation__
 *
 * To run a mutation, you first call `useCancelMembershipCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMembershipCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMembershipCancellationMutation, { data, loading, error }] = useCancelMembershipCancellationMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      membershipCancellationId: // value for 'membershipCancellationId'
 *   },
 * });
 */
export function useCancelMembershipCancellationMutation(baseOptions?: Apollo.MutationHookOptions<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>(CancelMembershipCancellationDocument, options);
      }
export type CancelMembershipCancellationMutationHookResult = ReturnType<typeof useCancelMembershipCancellationMutation>;
export type CancelMembershipCancellationMutationResult = Apollo.MutationResult<CancelMembershipCancellationMutation>;
export type CancelMembershipCancellationMutationOptions = Apollo.BaseMutationOptions<CancelMembershipCancellationMutation, CancelMembershipCancellationMutationVariables>;
export const GetMembershipCancellationDocument = gql`
    query getMembershipCancellation($memberId: ID!, $id: ID!) {
  getMembershipCancellation(memberId: $memberId, id: $id) {
    id
    cancellationFeeAmount
    cancelReason
    memberId
    companyId
    memberMembershipId
    endDate
  }
}
    `;

/**
 * __useGetMembershipCancellationQuery__
 *
 * To run a query within a React component, call `useGetMembershipCancellationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipCancellationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipCancellationQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipCancellationQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>(GetMembershipCancellationDocument, options);
      }
export function useGetMembershipCancellationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>(GetMembershipCancellationDocument, options);
        }
export type GetMembershipCancellationQueryHookResult = ReturnType<typeof useGetMembershipCancellationQuery>;
export type GetMembershipCancellationLazyQueryHookResult = ReturnType<typeof useGetMembershipCancellationLazyQuery>;
export type GetMembershipCancellationQueryResult = Apollo.QueryResult<GetMembershipCancellationQuery, GetMembershipCancellationQueryVariables>;
export const SuspendMyMembershipDocument = gql`
    mutation suspendMyMembership($memberId: ID!, $input: SuspendMyMembershipInput!) {
  suspendMyMembership(memberId: $memberId, input: $input) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipSuspension {
      id
      suspensionFeeAmount
      suspendReason
      memberId
      companyId
      memberMembershipId
      startDate
      endDate
      clubId
      requireApproval
      approvedAt
      deniedAt
      deniedReason
      handledByStaffId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SuspendMyMembershipMutationFn = Apollo.MutationFunction<SuspendMyMembershipMutation, SuspendMyMembershipMutationVariables>;

/**
 * __useSuspendMyMembershipMutation__
 *
 * To run a mutation, you first call `useSuspendMyMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuspendMyMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suspendMyMembershipMutation, { data, loading, error }] = useSuspendMyMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuspendMyMembershipMutation(baseOptions?: Apollo.MutationHookOptions<SuspendMyMembershipMutation, SuspendMyMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuspendMyMembershipMutation, SuspendMyMembershipMutationVariables>(SuspendMyMembershipDocument, options);
      }
export type SuspendMyMembershipMutationHookResult = ReturnType<typeof useSuspendMyMembershipMutation>;
export type SuspendMyMembershipMutationResult = Apollo.MutationResult<SuspendMyMembershipMutation>;
export type SuspendMyMembershipMutationOptions = Apollo.BaseMutationOptions<SuspendMyMembershipMutation, SuspendMyMembershipMutationVariables>;
export const StopMyMembershipSuspensionDocument = gql`
    mutation stopMyMembershipSuspension($memberId: ID!, $id: ID!) {
  stopMyMembershipSuspension(memberId: $memberId, id: $id) {
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
    }
    membershipSuspension {
      id
      suspensionFeeAmount
      suspendReason
      memberId
      companyId
      memberMembershipId
      startDate
      endDate
      clubId
      requireApproval
      approvedAt
      deniedAt
      deniedReason
      handledByStaffId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type StopMyMembershipSuspensionMutationFn = Apollo.MutationFunction<StopMyMembershipSuspensionMutation, StopMyMembershipSuspensionMutationVariables>;

/**
 * __useStopMyMembershipSuspensionMutation__
 *
 * To run a mutation, you first call `useStopMyMembershipSuspensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopMyMembershipSuspensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopMyMembershipSuspensionMutation, { data, loading, error }] = useStopMyMembershipSuspensionMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopMyMembershipSuspensionMutation(baseOptions?: Apollo.MutationHookOptions<StopMyMembershipSuspensionMutation, StopMyMembershipSuspensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopMyMembershipSuspensionMutation, StopMyMembershipSuspensionMutationVariables>(StopMyMembershipSuspensionDocument, options);
      }
export type StopMyMembershipSuspensionMutationHookResult = ReturnType<typeof useStopMyMembershipSuspensionMutation>;
export type StopMyMembershipSuspensionMutationResult = Apollo.MutationResult<StopMyMembershipSuspensionMutation>;
export type StopMyMembershipSuspensionMutationOptions = Apollo.BaseMutationOptions<StopMyMembershipSuspensionMutation, StopMyMembershipSuspensionMutationVariables>;
export const GetMembershipSuspensionDocument = gql`
    query getMembershipSuspension($memberId: ID!, $id: ID!) {
  getMembershipSuspension(memberId: $memberId, id: $id) {
    id
    suspensionFeeAmount
    suspendReason
    memberId
    companyId
    memberMembershipId
    startDate
    endDate
    clubId
    requireApproval
    approvedAt
    deniedAt
    deniedReason
    handledByStaffId
  }
}
    `;

/**
 * __useGetMembershipSuspensionQuery__
 *
 * To run a query within a React component, call `useGetMembershipSuspensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipSuspensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipSuspensionQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipSuspensionQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>(GetMembershipSuspensionDocument, options);
      }
export function useGetMembershipSuspensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>(GetMembershipSuspensionDocument, options);
        }
export type GetMembershipSuspensionQueryHookResult = ReturnType<typeof useGetMembershipSuspensionQuery>;
export type GetMembershipSuspensionLazyQueryHookResult = ReturnType<typeof useGetMembershipSuspensionLazyQuery>;
export type GetMembershipSuspensionQueryResult = Apollo.QueryResult<GetMembershipSuspensionQuery, GetMembershipSuspensionQueryVariables>;
export const StartPublicMembershipSignUpDocument = gql`
    mutation startPublicMembershipSignUp($input: StartPublicMembershipSignUpInput!) {
  startPublicMembershipSignUp(input: $input) {
    success
    errors {
      type
      message
    }
  }
}
    `;
export type StartPublicMembershipSignUpMutationFn = Apollo.MutationFunction<StartPublicMembershipSignUpMutation, StartPublicMembershipSignUpMutationVariables>;

/**
 * __useStartPublicMembershipSignUpMutation__
 *
 * To run a mutation, you first call `useStartPublicMembershipSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPublicMembershipSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPublicMembershipSignUpMutation, { data, loading, error }] = useStartPublicMembershipSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPublicMembershipSignUpMutation(baseOptions?: Apollo.MutationHookOptions<StartPublicMembershipSignUpMutation, StartPublicMembershipSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPublicMembershipSignUpMutation, StartPublicMembershipSignUpMutationVariables>(StartPublicMembershipSignUpDocument, options);
      }
export type StartPublicMembershipSignUpMutationHookResult = ReturnType<typeof useStartPublicMembershipSignUpMutation>;
export type StartPublicMembershipSignUpMutationResult = Apollo.MutationResult<StartPublicMembershipSignUpMutation>;
export type StartPublicMembershipSignUpMutationOptions = Apollo.BaseMutationOptions<StartPublicMembershipSignUpMutation, StartPublicMembershipSignUpMutationVariables>;
export const GetMemberDocument = gql`
    query getMember($id: ID!) {
  getMember(id: $id) {
    id
    email
    givenName
    familyName
    displayName
    mobileNumber
    status
    gender
    emailVerified
    address
    dateOfBirth
    profilePictureUrl
    activeMembershipId
    activeMemberMembershipId
    clubIds
    homeClubId
    homeClubName
    barcode
    dependantOf
    dependantIds
    amountOwed {
      amount
      currency {
        code
        base
        exponent
      }
      scale
    }
  }
}
    `;

/**
 * __useGetMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberQuery, GetMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberQuery, GetMemberQueryVariables>(GetMemberDocument, options);
      }
export function useGetMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberQuery, GetMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberQuery, GetMemberQueryVariables>(GetMemberDocument, options);
        }
export type GetMemberQueryHookResult = ReturnType<typeof useGetMemberQuery>;
export type GetMemberLazyQueryHookResult = ReturnType<typeof useGetMemberLazyQuery>;
export type GetMemberQueryResult = Apollo.QueryResult<GetMemberQuery, GetMemberQueryVariables>;
export const AgreeToCurrentMembershipDocument = gql`
    mutation agreeToCurrentMembership($memberId: ID!, $input: AgreeToMembershipInput!) {
  agreeToCurrentMembership(memberId: $memberId, input: $input) {
    member {
      id
      status
    }
    memberMembership {
      id
      memberName
      membershipName
      memberId
      membershipId
      companyId
      startDate
      billingStartDate
      endDate
      paymentFrequency
      paymentAmount
      minimumAmountRemaining {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      visitLimit
      visitLimitFrequency
      lengthFrequency
      lengthAmount
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
      dishonorFee
      hasCustomFees
      membershipCancellationId
      membershipSuspensionId
      restrictedClassTypeIds
      paidInFull
      initialDiscountAmount {
        amount
        currency {
          code
          base
          exponent
        }
        scale
      }
      initialDiscountPayments
    }
  }
}
    `;
export type AgreeToCurrentMembershipMutationFn = Apollo.MutationFunction<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>;

/**
 * __useAgreeToCurrentMembershipMutation__
 *
 * To run a mutation, you first call `useAgreeToCurrentMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeToCurrentMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeToCurrentMembershipMutation, { data, loading, error }] = useAgreeToCurrentMembershipMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgreeToCurrentMembershipMutation(baseOptions?: Apollo.MutationHookOptions<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>(AgreeToCurrentMembershipDocument, options);
      }
export type AgreeToCurrentMembershipMutationHookResult = ReturnType<typeof useAgreeToCurrentMembershipMutation>;
export type AgreeToCurrentMembershipMutationResult = Apollo.MutationResult<AgreeToCurrentMembershipMutation>;
export type AgreeToCurrentMembershipMutationOptions = Apollo.BaseMutationOptions<AgreeToCurrentMembershipMutation, AgreeToCurrentMembershipMutationVariables>;
export const GetMemberChargesForMemberDocument = gql`
    query getMemberChargesForMember($memberId: String!, $id: ID, $limit: Int, $startsAt: String) {
  getMemberChargesForMember(
    memberId: $memberId
    id: $id
    limit: $limit
    startsAt: $startsAt
  ) {
    items {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberChargesForMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberChargesForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberChargesForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberChargesForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      startsAt: // value for 'startsAt'
 *   },
 * });
 */
export function useGetMemberChargesForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>(GetMemberChargesForMemberDocument, options);
      }
export function useGetMemberChargesForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>(GetMemberChargesForMemberDocument, options);
        }
export type GetMemberChargesForMemberQueryHookResult = ReturnType<typeof useGetMemberChargesForMemberQuery>;
export type GetMemberChargesForMemberLazyQueryHookResult = ReturnType<typeof useGetMemberChargesForMemberLazyQuery>;
export type GetMemberChargesForMemberQueryResult = Apollo.QueryResult<GetMemberChargesForMemberQuery, GetMemberChargesForMemberQueryVariables>;
export const GetMemberChargeDocument = gql`
    query getMemberCharge($memberId: ID!, $id: ID!) {
  getMemberCharge(memberId: $memberId, id: $id) {
    id
    date
    memberId
    companyId
    status
    serviceAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    dishonorAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    totalOwed {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    totalPaid {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    description
    serviceType
    servicePeriod
    serviceId
  }
}
    `;

/**
 * __useGetMemberChargeQuery__
 *
 * To run a query within a React component, call `useGetMemberChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberChargeQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMemberChargeQuery(baseOptions: Apollo.QueryHookOptions<GetMemberChargeQuery, GetMemberChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberChargeQuery, GetMemberChargeQueryVariables>(GetMemberChargeDocument, options);
      }
export function useGetMemberChargeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberChargeQuery, GetMemberChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberChargeQuery, GetMemberChargeQueryVariables>(GetMemberChargeDocument, options);
        }
export type GetMemberChargeQueryHookResult = ReturnType<typeof useGetMemberChargeQuery>;
export type GetMemberChargeLazyQueryHookResult = ReturnType<typeof useGetMemberChargeLazyQuery>;
export type GetMemberChargeQueryResult = Apollo.QueryResult<GetMemberChargeQuery, GetMemberChargeQueryVariables>;
export const SettleMemberChargeDocument = gql`
    mutation settleMemberCharge($memberId: ID!, $memberChargeId: ID!) {
  settleMemberCharge(memberId: $memberId, memberChargeId: $memberChargeId) {
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    member {
      id
      status
      amountOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SettleMemberChargeMutationFn = Apollo.MutationFunction<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>;

/**
 * __useSettleMemberChargeMutation__
 *
 * To run a mutation, you first call `useSettleMemberChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettleMemberChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settleMemberChargeMutation, { data, loading, error }] = useSettleMemberChargeMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *   },
 * });
 */
export function useSettleMemberChargeMutation(baseOptions?: Apollo.MutationHookOptions<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>(SettleMemberChargeDocument, options);
      }
export type SettleMemberChargeMutationHookResult = ReturnType<typeof useSettleMemberChargeMutation>;
export type SettleMemberChargeMutationResult = Apollo.MutationResult<SettleMemberChargeMutation>;
export type SettleMemberChargeMutationOptions = Apollo.BaseMutationOptions<SettleMemberChargeMutation, SettleMemberChargeMutationVariables>;
export const SettleAccountDocument = gql`
    mutation settleAccount($memberId: ID!) {
  settleAccount(memberId: $memberId) {
    memberCharge {
      id
      date
      memberId
      companyId
      status
      serviceAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      dishonorAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      totalPaid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      description
      serviceType
      servicePeriod
      serviceId
    }
    member {
      id
      status
      amountOwed {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SettleAccountMutationFn = Apollo.MutationFunction<SettleAccountMutation, SettleAccountMutationVariables>;

/**
 * __useSettleAccountMutation__
 *
 * To run a mutation, you first call `useSettleAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSettleAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [settleAccountMutation, { data, loading, error }] = useSettleAccountMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useSettleAccountMutation(baseOptions?: Apollo.MutationHookOptions<SettleAccountMutation, SettleAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SettleAccountMutation, SettleAccountMutationVariables>(SettleAccountDocument, options);
      }
export type SettleAccountMutationHookResult = ReturnType<typeof useSettleAccountMutation>;
export type SettleAccountMutationResult = Apollo.MutationResult<SettleAccountMutation>;
export type SettleAccountMutationOptions = Apollo.BaseMutationOptions<SettleAccountMutation, SettleAccountMutationVariables>;
export const GetActivePaymentDetailsForMemberDocument = gql`
    query getActivePaymentDetailsForMember($memberId: ID!, $paymentMethodType: PaymentMethodType!) {
  getActivePaymentDetailsForMember(
    memberId: $memberId
    paymentMethodType: $paymentMethodType
  ) {
    memberId
    membershipId
    baseCurrency {
      code
      base
      exponent
    }
    directDebitProviderId
    nextChargeDate
    firstAmount {
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subTotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
    regularAmount {
      amount {
        amount {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        total {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        subTotal {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        tax {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        transactionFee {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        merchantFee {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
        discount {
          amount
          currency {
            base
            code
            exponent
          }
          scale
        }
      }
      frequency
    }
    memberFees {
      joinFee
      adminFee
      fobFee
      cancellationFee
      suspensionFee
    }
    transactionFees {
      transactionFee
      merchantFeePercentage
      dishonorFee
    }
  }
}
    `;

/**
 * __useGetActivePaymentDetailsForMemberQuery__
 *
 * To run a query within a React component, call `useGetActivePaymentDetailsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivePaymentDetailsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivePaymentDetailsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useGetActivePaymentDetailsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>(GetActivePaymentDetailsForMemberDocument, options);
      }
export function useGetActivePaymentDetailsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>(GetActivePaymentDetailsForMemberDocument, options);
        }
export type GetActivePaymentDetailsForMemberQueryHookResult = ReturnType<typeof useGetActivePaymentDetailsForMemberQuery>;
export type GetActivePaymentDetailsForMemberLazyQueryHookResult = ReturnType<typeof useGetActivePaymentDetailsForMemberLazyQuery>;
export type GetActivePaymentDetailsForMemberQueryResult = Apollo.QueryResult<GetActivePaymentDetailsForMemberQuery, GetActivePaymentDetailsForMemberQueryVariables>;
export const GetScheduledMemberPaymentsForMemberDocument = gql`
    query getScheduledMemberPaymentsForMember($memberId: String!, $id: ID, $serviceType: PaymentServiceType, $clubId: String, $limit: Int, $nextToken: String) {
  getScheduledMemberPaymentsForMember(
    memberId: $memberId
    id: $id
    serviceType: $serviceType
    clubId: $clubId
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      memberId
      companyId
      scheduledAt
      memberMembershipId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
    }
    nextToken
  }
}
    `;

/**
 * __useGetScheduledMemberPaymentsForMemberQuery__
 *
 * To run a query within a React component, call `useGetScheduledMemberPaymentsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledMemberPaymentsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledMemberPaymentsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      serviceType: // value for 'serviceType'
 *      clubId: // value for 'clubId'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useGetScheduledMemberPaymentsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>(GetScheduledMemberPaymentsForMemberDocument, options);
      }
export function useGetScheduledMemberPaymentsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>(GetScheduledMemberPaymentsForMemberDocument, options);
        }
export type GetScheduledMemberPaymentsForMemberQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForMemberQuery>;
export type GetScheduledMemberPaymentsForMemberLazyQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForMemberLazyQuery>;
export type GetScheduledMemberPaymentsForMemberQueryResult = Apollo.QueryResult<GetScheduledMemberPaymentsForMemberQuery, GetScheduledMemberPaymentsForMemberQueryVariables>;
export const GetMemberPaymentsForMemberDocument = gql`
    query getMemberPaymentsForMember($memberId: String!, $id: ID, $limit: Int, $startsAt: String) {
  getMemberPaymentsForMember(
    memberId: $memberId
    id: $id
    limit: $limit
    startsAt: $startsAt
  ) {
    items {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
    }
    nextToken
  }
}
    `;

/**
 * __useGetMemberPaymentsForMemberQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentsForMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentsForMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentsForMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      startsAt: // value for 'startsAt'
 *   },
 * });
 */
export function useGetMemberPaymentsForMemberQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>(GetMemberPaymentsForMemberDocument, options);
      }
export function useGetMemberPaymentsForMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>(GetMemberPaymentsForMemberDocument, options);
        }
export type GetMemberPaymentsForMemberQueryHookResult = ReturnType<typeof useGetMemberPaymentsForMemberQuery>;
export type GetMemberPaymentsForMemberLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentsForMemberLazyQuery>;
export type GetMemberPaymentsForMemberQueryResult = Apollo.QueryResult<GetMemberPaymentsForMemberQuery, GetMemberPaymentsForMemberQueryVariables>;
export const ReprocessFailedMemberPaymentDocument = gql`
    mutation reprocessFailedMemberPayment($memberId: ID!, $id: ID!) {
  reprocessFailedMemberPayment(memberId: $memberId, id: $id) {
    memberPayment {
      id
      memberId
      companyId
      processedAt
      memberPaymentMethodId
      status
      failReason
      reprocessingFor
      reprocessedBy
      providerId
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discountAmount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      transactionFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      merchantFee {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      serviceType
      serviceId
      servicePeriod
      attemptNumber
      invoiceId
    }
    errors {
      type
      message
    }
  }
}
    `;
export type ReprocessFailedMemberPaymentMutationFn = Apollo.MutationFunction<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>;

/**
 * __useReprocessFailedMemberPaymentMutation__
 *
 * To run a mutation, you first call `useReprocessFailedMemberPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessFailedMemberPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessFailedMemberPaymentMutation, { data, loading, error }] = useReprocessFailedMemberPaymentMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReprocessFailedMemberPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>(ReprocessFailedMemberPaymentDocument, options);
      }
export type ReprocessFailedMemberPaymentMutationHookResult = ReturnType<typeof useReprocessFailedMemberPaymentMutation>;
export type ReprocessFailedMemberPaymentMutationResult = Apollo.MutationResult<ReprocessFailedMemberPaymentMutation>;
export type ReprocessFailedMemberPaymentMutationOptions = Apollo.BaseMutationOptions<ReprocessFailedMemberPaymentMutation, ReprocessFailedMemberPaymentMutationVariables>;
export const GetScheduledMemberPaymentsForChargeIdDocument = gql`
    query getScheduledMemberPaymentsForChargeId($memberId: ID!, $memberChargeId: ID!) {
  getScheduledMemberPaymentsForChargeId(
    memberId: $memberId
    memberChargeId: $memberChargeId
  ) {
    id
    memberId
    companyId
    scheduledAt
    memberMembershipId
    membershipDays
    proRataDays
    proRataAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    amount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    discountAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    transactionFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    merchantFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    subtotal {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    tax {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    serviceType
    serviceId
    servicePeriod
    attemptNumber
    description
    memberChargeId
  }
}
    `;

/**
 * __useGetScheduledMemberPaymentsForChargeIdQuery__
 *
 * To run a query within a React component, call `useGetScheduledMemberPaymentsForChargeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledMemberPaymentsForChargeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledMemberPaymentsForChargeIdQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *   },
 * });
 */
export function useGetScheduledMemberPaymentsForChargeIdQuery(baseOptions: Apollo.QueryHookOptions<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>(GetScheduledMemberPaymentsForChargeIdDocument, options);
      }
export function useGetScheduledMemberPaymentsForChargeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>(GetScheduledMemberPaymentsForChargeIdDocument, options);
        }
export type GetScheduledMemberPaymentsForChargeIdQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForChargeIdQuery>;
export type GetScheduledMemberPaymentsForChargeIdLazyQueryHookResult = ReturnType<typeof useGetScheduledMemberPaymentsForChargeIdLazyQuery>;
export type GetScheduledMemberPaymentsForChargeIdQueryResult = Apollo.QueryResult<GetScheduledMemberPaymentsForChargeIdQuery, GetScheduledMemberPaymentsForChargeIdQueryVariables>;
export const GetMemberPaymentsForChargeIdDocument = gql`
    query getMemberPaymentsForChargeId($memberId: ID!, $memberChargeId: ID!) {
  getMemberPaymentsForChargeId(
    memberId: $memberId
    memberChargeId: $memberChargeId
  ) {
    id
    memberId
    companyId
    processedAt
    memberPaymentMethodId
    status
    failReason
    reprocessingFor
    reprocessedBy
    providerId
    membershipDays
    proRataDays
    proRataAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    amount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    discountAmount {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    transactionFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    merchantFee {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    subtotal {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    tax {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    total {
      amount
      currency {
        base
        code
        exponent
      }
      scale
    }
    serviceType
    serviceId
    servicePeriod
    attemptNumber
    invoiceId
    description
    memberChargeId
  }
}
    `;

/**
 * __useGetMemberPaymentsForChargeIdQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentsForChargeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentsForChargeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentsForChargeIdQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      memberChargeId: // value for 'memberChargeId'
 *   },
 * });
 */
export function useGetMemberPaymentsForChargeIdQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>(GetMemberPaymentsForChargeIdDocument, options);
      }
export function useGetMemberPaymentsForChargeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>(GetMemberPaymentsForChargeIdDocument, options);
        }
export type GetMemberPaymentsForChargeIdQueryHookResult = ReturnType<typeof useGetMemberPaymentsForChargeIdQuery>;
export type GetMemberPaymentsForChargeIdLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentsForChargeIdLazyQuery>;
export type GetMemberPaymentsForChargeIdQueryResult = Apollo.QueryResult<GetMemberPaymentsForChargeIdQuery, GetMemberPaymentsForChargeIdQueryVariables>;
export const GetMemberPaymentMethodsDocument = gql`
    query getMemberPaymentMethods($memberId: ID!) {
  getMemberPaymentMethods(memberId: $memberId) {
    id
    isDefault
    memberId
    companyId
    type
    providerId
    maskedNumber
    expiryMonth
    expiryYear
    accountName
  }
}
    `;

/**
 * __useGetMemberPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentMethodsQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useGetMemberPaymentMethodsQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>(GetMemberPaymentMethodsDocument, options);
      }
export function useGetMemberPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>(GetMemberPaymentMethodsDocument, options);
        }
export type GetMemberPaymentMethodsQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodsQuery>;
export type GetMemberPaymentMethodsLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodsLazyQuery>;
export type GetMemberPaymentMethodsQueryResult = Apollo.QueryResult<GetMemberPaymentMethodsQuery, GetMemberPaymentMethodsQueryVariables>;
export const GetMemberPaymentMethodDocument = gql`
    query getMemberPaymentMethod($memberId: ID!, $id: ID!) {
  getMemberPaymentMethod(memberId: $memberId, id: $id) {
    id
    isDefault
    memberId
    companyId
    type
    providerId
    maskedNumber
    expiryMonth
    expiryYear
    accountName
  }
}
    `;

/**
 * __useGetMemberPaymentMethodQuery__
 *
 * To run a query within a React component, call `useGetMemberPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMemberPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMemberPaymentMethodQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMemberPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>(GetMemberPaymentMethodDocument, options);
      }
export function useGetMemberPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>(GetMemberPaymentMethodDocument, options);
        }
export type GetMemberPaymentMethodQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodQuery>;
export type GetMemberPaymentMethodLazyQueryHookResult = ReturnType<typeof useGetMemberPaymentMethodLazyQuery>;
export type GetMemberPaymentMethodQueryResult = Apollo.QueryResult<GetMemberPaymentMethodQuery, GetMemberPaymentMethodQueryVariables>;
export const AddMemberPaymentMethodDocument = gql`
    mutation addMemberPaymentMethod($memberId: ID!, $input: AddMemberPaymentMethodInput!) {
  addMemberPaymentMethod(memberId: $memberId, input: $input) {
    memberPaymentMethod {
      id
      isDefault
      memberId
      companyId
      type
      providerId
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type AddMemberPaymentMethodMutationFn = Apollo.MutationFunction<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>;

/**
 * __useAddMemberPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddMemberPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberPaymentMethodMutation, { data, loading, error }] = useAddMemberPaymentMethodMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>(AddMemberPaymentMethodDocument, options);
      }
export type AddMemberPaymentMethodMutationHookResult = ReturnType<typeof useAddMemberPaymentMethodMutation>;
export type AddMemberPaymentMethodMutationResult = Apollo.MutationResult<AddMemberPaymentMethodMutation>;
export type AddMemberPaymentMethodMutationOptions = Apollo.BaseMutationOptions<AddMemberPaymentMethodMutation, AddMemberPaymentMethodMutationVariables>;
export const RemoveMemberPaymentMethodDocument = gql`
    mutation removeMemberPaymentMethod($memberId: ID!, $id: ID!) {
  removeMemberPaymentMethod(memberId: $memberId, id: $id) {
    memberPaymentMethod {
      id
      isDefault
      memberId
      companyId
      type
      providerId
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type RemoveMemberPaymentMethodMutationFn = Apollo.MutationFunction<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>;

/**
 * __useRemoveMemberPaymentMethodMutation__
 *
 * To run a mutation, you first call `useRemoveMemberPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberPaymentMethodMutation, { data, loading, error }] = useRemoveMemberPaymentMethodMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveMemberPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>(RemoveMemberPaymentMethodDocument, options);
      }
export type RemoveMemberPaymentMethodMutationHookResult = ReturnType<typeof useRemoveMemberPaymentMethodMutation>;
export type RemoveMemberPaymentMethodMutationResult = Apollo.MutationResult<RemoveMemberPaymentMethodMutation>;
export type RemoveMemberPaymentMethodMutationOptions = Apollo.BaseMutationOptions<RemoveMemberPaymentMethodMutation, RemoveMemberPaymentMethodMutationVariables>;
export const SetMemberPaymentMethodAsDefaultDocument = gql`
    mutation setMemberPaymentMethodAsDefault($memberId: ID!, $id: ID!) {
  setMemberPaymentMethodAsDefault(memberId: $memberId, id: $id) {
    memberPaymentMethod {
      id
      isDefault
      memberId
      companyId
      type
      providerId
      maskedNumber
      expiryMonth
      expiryYear
      accountName
    }
    errors {
      type
      message
    }
  }
}
    `;
export type SetMemberPaymentMethodAsDefaultMutationFn = Apollo.MutationFunction<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>;

/**
 * __useSetMemberPaymentMethodAsDefaultMutation__
 *
 * To run a mutation, you first call `useSetMemberPaymentMethodAsDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMemberPaymentMethodAsDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMemberPaymentMethodAsDefaultMutation, { data, loading, error }] = useSetMemberPaymentMethodAsDefaultMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetMemberPaymentMethodAsDefaultMutation(baseOptions?: Apollo.MutationHookOptions<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>(SetMemberPaymentMethodAsDefaultDocument, options);
      }
export type SetMemberPaymentMethodAsDefaultMutationHookResult = ReturnType<typeof useSetMemberPaymentMethodAsDefaultMutation>;
export type SetMemberPaymentMethodAsDefaultMutationResult = Apollo.MutationResult<SetMemberPaymentMethodAsDefaultMutation>;
export type SetMemberPaymentMethodAsDefaultMutationOptions = Apollo.BaseMutationOptions<SetMemberPaymentMethodAsDefaultMutation, SetMemberPaymentMethodAsDefaultMutationVariables>;
export const GetAmountForMembershipFrequencyDocument = gql`
    query getAmountForMembershipFrequency($id: ID!, $paymentFrequency: MembershipPaymentFrequency!) {
  getAmountForMembershipFrequency(id: $id, paymentFrequency: $paymentFrequency) {
    membershipAmount {
      currency {
        code
        base
        exponent
      }
      amount
      scale
    }
    suspensionFee {
      currency {
        code
        base
        exponent
      }
      amount
      scale
    }
  }
}
    `;

/**
 * __useGetAmountForMembershipFrequencyQuery__
 *
 * To run a query within a React component, call `useGetAmountForMembershipFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAmountForMembershipFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAmountForMembershipFrequencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentFrequency: // value for 'paymentFrequency'
 *   },
 * });
 */
export function useGetAmountForMembershipFrequencyQuery(baseOptions: Apollo.QueryHookOptions<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>(GetAmountForMembershipFrequencyDocument, options);
      }
export function useGetAmountForMembershipFrequencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>(GetAmountForMembershipFrequencyDocument, options);
        }
export type GetAmountForMembershipFrequencyQueryHookResult = ReturnType<typeof useGetAmountForMembershipFrequencyQuery>;
export type GetAmountForMembershipFrequencyLazyQueryHookResult = ReturnType<typeof useGetAmountForMembershipFrequencyLazyQuery>;
export type GetAmountForMembershipFrequencyQueryResult = Apollo.QueryResult<GetAmountForMembershipFrequencyQuery, GetAmountForMembershipFrequencyQueryVariables>;
export const GetMembershipDocument = gql`
    query getMembership($id: ID!) {
  getMembership(id: $id) {
    availablePaymentPeriods
    description
    id
    lengthAmount
    lengthFrequency
    name
    paymentAmount
    paymentFrequency
    publishedAt
    thumbnailImageUrl
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    allowPaidInFull
    payInFullOptions {
      months
      amount
    }
    paidInFullOnly
    availableToPublic
    order
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
    initialDiscountPayments
    initialDiscountPercentage
  }
}
    `;

/**
 * __useGetMembershipQuery__
 *
 * To run a query within a React component, call `useGetMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembershipQuery(baseOptions: Apollo.QueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
      }
export function useGetMembershipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembershipQuery, GetMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembershipQuery, GetMembershipQueryVariables>(GetMembershipDocument, options);
        }
export type GetMembershipQueryHookResult = ReturnType<typeof useGetMembershipQuery>;
export type GetMembershipLazyQueryHookResult = ReturnType<typeof useGetMembershipLazyQuery>;
export type GetMembershipQueryResult = Apollo.QueryResult<GetMembershipQuery, GetMembershipQueryVariables>;
export const GetPublicMembershipsDocument = gql`
    query getPublicMemberships($companyId: ID!) {
  getPublicMemberships(companyId: $companyId) {
    id
    name
    description
    publishedAt
    thumbnailImageUrl
    paymentFrequency
    paymentAmount
    availablePaymentPeriods
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    cancellationFee
    suspensionFee
    allowPaidInFull
    paidInFullOnly
    availableToPublic
    order
    payInFullOptions {
      months
      amount
    }
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
  }
}
    `;

/**
 * __useGetPublicMembershipsQuery__
 *
 * To run a query within a React component, call `useGetPublicMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicMembershipsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPublicMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicMembershipsQuery, GetPublicMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicMembershipsQuery, GetPublicMembershipsQueryVariables>(GetPublicMembershipsDocument, options);
      }
export function useGetPublicMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicMembershipsQuery, GetPublicMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicMembershipsQuery, GetPublicMembershipsQueryVariables>(GetPublicMembershipsDocument, options);
        }
export type GetPublicMembershipsQueryHookResult = ReturnType<typeof useGetPublicMembershipsQuery>;
export type GetPublicMembershipsLazyQueryHookResult = ReturnType<typeof useGetPublicMembershipsLazyQuery>;
export type GetPublicMembershipsQueryResult = Apollo.QueryResult<GetPublicMembershipsQuery, GetPublicMembershipsQueryVariables>;
export const GetMyNotificationPreferencesDocument = gql`
    query getMyNotificationPreferences {
  getMyNotificationPreferences {
    classCancelled {
      email
      sms
      push
    }
    classTimeChanged {
      email
      sms
      push
    }
    classWaitlistAvailable {
      email
      sms
      push
    }
    classBooked {
      email
      sms
      push
    }
    paymentFailed {
      email
      sms
      push
    }
    paymentSucceeded {
      email
      sms
      push
    }
  }
}
    `;

/**
 * __useGetMyNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetMyNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
      }
export function useGetMyNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>(GetMyNotificationPreferencesDocument, options);
        }
export type GetMyNotificationPreferencesQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesQuery>;
export type GetMyNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetMyNotificationPreferencesLazyQuery>;
export type GetMyNotificationPreferencesQueryResult = Apollo.QueryResult<GetMyNotificationPreferencesQuery, GetMyNotificationPreferencesQueryVariables>;
export const UpdateNotificationPreferencesDocument = gql`
    mutation updateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
  updateNotificationPreferences(input: $input) {
    classCancelled {
      email
      sms
      push
    }
    classTimeChanged {
      email
      sms
      push
    }
    classWaitlistAvailable {
      email
      sms
      push
    }
    classBooked {
      email
      sms
      push
    }
    paymentFailed {
      email
      sms
      push
    }
    paymentSucceeded {
      email
      sms
      push
    }
  }
}
    `;
export type UpdateNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;

/**
 * __useUpdateNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferencesMutation, { data, loading, error }] = useUpdateNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>(UpdateNotificationPreferencesDocument, options);
      }
export type UpdateNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateNotificationPreferencesMutation>;
export type UpdateNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferencesMutation, UpdateNotificationPreferencesMutationVariables>;
export const GetOrderByInvoiceDocument = gql`
    query getOrderByInvoice($companyId: ID!, $clubId: ID!, $id: ID!) {
  getOrderByInvoice(companyId: $companyId, clubId: $clubId, id: $id) {
    order {
      id
      companyId
      status
      created
      memberName
      clubId
      discountPercentage
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      subtotal {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      tax {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      discount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      currency {
        base
        code
        exponent
      }
      memberPaymentId
      totalQuantity
      paid {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      outstanding {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      invoiceId
      refundReason
    }
    orderItems {
      id
      orderId
      companyId
      memberId
      clubId
      productId
      productStockId
      quantity
      amount {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
      total {
        amount
        currency {
          base
          code
          exponent
        }
        scale
      }
    }
  }
}
    `;

/**
 * __useGetOrderByInvoiceQuery__
 *
 * To run a query within a React component, call `useGetOrderByInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderByInvoiceQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      clubId: // value for 'clubId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderByInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetOrderByInvoiceQuery, GetOrderByInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderByInvoiceQuery, GetOrderByInvoiceQueryVariables>(GetOrderByInvoiceDocument, options);
      }
export function useGetOrderByInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderByInvoiceQuery, GetOrderByInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderByInvoiceQuery, GetOrderByInvoiceQueryVariables>(GetOrderByInvoiceDocument, options);
        }
export type GetOrderByInvoiceQueryHookResult = ReturnType<typeof useGetOrderByInvoiceQuery>;
export type GetOrderByInvoiceLazyQueryHookResult = ReturnType<typeof useGetOrderByInvoiceLazyQuery>;
export type GetOrderByInvoiceQueryResult = Apollo.QueryResult<GetOrderByInvoiceQuery, GetOrderByInvoiceQueryVariables>;
export const GetPackagelDocument = gql`
    query getPackagel($id: ID!) {
  getPackage(id: $id) {
    id
    name
    description
    publishedAt
    thumbnailImageUrl
    paymentAmount
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
  }
}
    `;

/**
 * __useGetPackagelQuery__
 *
 * To run a query within a React component, call `useGetPackagelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPackagelQuery(baseOptions: Apollo.QueryHookOptions<GetPackagelQuery, GetPackagelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagelQuery, GetPackagelQueryVariables>(GetPackagelDocument, options);
      }
export function useGetPackagelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagelQuery, GetPackagelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagelQuery, GetPackagelQueryVariables>(GetPackagelDocument, options);
        }
export type GetPackagelQueryHookResult = ReturnType<typeof useGetPackagelQuery>;
export type GetPackagelLazyQueryHookResult = ReturnType<typeof useGetPackagelLazyQuery>;
export type GetPackagelQueryResult = Apollo.QueryResult<GetPackagelQuery, GetPackagelQueryVariables>;
export const GetPublicPackagesDocument = gql`
    query getPublicPackages($companyId: ID!) {
  getPublicPackages(companyId: $companyId) {
    id
    name
    description
    publishedAt
    thumbnailImageUrl
    paymentAmount
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
  }
}
    `;

/**
 * __useGetPublicPackagesQuery__
 *
 * To run a query within a React component, call `useGetPublicPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicPackagesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPublicPackagesQuery(baseOptions: Apollo.QueryHookOptions<GetPublicPackagesQuery, GetPublicPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicPackagesQuery, GetPublicPackagesQueryVariables>(GetPublicPackagesDocument, options);
      }
export function useGetPublicPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicPackagesQuery, GetPublicPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicPackagesQuery, GetPublicPackagesQueryVariables>(GetPublicPackagesDocument, options);
        }
export type GetPublicPackagesQueryHookResult = ReturnType<typeof useGetPublicPackagesQuery>;
export type GetPublicPackagesLazyQueryHookResult = ReturnType<typeof useGetPublicPackagesLazyQuery>;
export type GetPublicPackagesQueryResult = Apollo.QueryResult<GetPublicPackagesQuery, GetPublicPackagesQueryVariables>;
export const PublicSearchDocument = gql`
    query publicSearch($input: PublicSearchInput!) {
  publicSearch(input: $input) {
    items {
      id
      title
      detail
      thumbnailUrl
      type
      address
    }
    page
    pageCount
    perPage
    resultCount
  }
}
    `;

/**
 * __usePublicSearchQuery__
 *
 * To run a query within a React component, call `usePublicSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicSearchQuery(baseOptions: Apollo.QueryHookOptions<PublicSearchQuery, PublicSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicSearchQuery, PublicSearchQueryVariables>(PublicSearchDocument, options);
      }
export function usePublicSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicSearchQuery, PublicSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicSearchQuery, PublicSearchQueryVariables>(PublicSearchDocument, options);
        }
export type PublicSearchQueryHookResult = ReturnType<typeof usePublicSearchQuery>;
export type PublicSearchLazyQueryHookResult = ReturnType<typeof usePublicSearchLazyQuery>;
export type PublicSearchQueryResult = Apollo.QueryResult<PublicSearchQuery, PublicSearchQueryVariables>;
export const GetTrialDocument = gql`
    query getTrial($id: ID!) {
  getTrial(id: $id) {
    id
    name
    description
    publishedAt
    thumbnailImageUrl
    paymentAmount
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
  }
}
    `;

/**
 * __useGetTrialQuery__
 *
 * To run a query within a React component, call `useGetTrialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrialQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTrialQuery(baseOptions: Apollo.QueryHookOptions<GetTrialQuery, GetTrialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrialQuery, GetTrialQueryVariables>(GetTrialDocument, options);
      }
export function useGetTrialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrialQuery, GetTrialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrialQuery, GetTrialQueryVariables>(GetTrialDocument, options);
        }
export type GetTrialQueryHookResult = ReturnType<typeof useGetTrialQuery>;
export type GetTrialLazyQueryHookResult = ReturnType<typeof useGetTrialLazyQuery>;
export type GetTrialQueryResult = Apollo.QueryResult<GetTrialQuery, GetTrialQueryVariables>;
export const GetPublicTrialsDocument = gql`
    query getPublicTrials($companyId: ID!) {
  getPublicTrials(companyId: $companyId) {
    id
    name
    description
    publishedAt
    thumbnailImageUrl
    paymentAmount
    lengthAmount
    lengthFrequency
    joinFee
    adminFee
    fobFee
    baseCurrency {
      code
      base
      exponent
    }
    restrictedClassTypeIds
  }
}
    `;

/**
 * __useGetPublicTrialsQuery__
 *
 * To run a query within a React component, call `useGetPublicTrialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicTrialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicTrialsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPublicTrialsQuery(baseOptions: Apollo.QueryHookOptions<GetPublicTrialsQuery, GetPublicTrialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicTrialsQuery, GetPublicTrialsQueryVariables>(GetPublicTrialsDocument, options);
      }
export function useGetPublicTrialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicTrialsQuery, GetPublicTrialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicTrialsQuery, GetPublicTrialsQueryVariables>(GetPublicTrialsDocument, options);
        }
export type GetPublicTrialsQueryHookResult = ReturnType<typeof useGetPublicTrialsQuery>;
export type GetPublicTrialsLazyQueryHookResult = ReturnType<typeof useGetPublicTrialsLazyQuery>;
export type GetPublicTrialsQueryResult = Apollo.QueryResult<GetPublicTrialsQuery, GetPublicTrialsQueryVariables>;